/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 * Created by jpatel
 * Color contstants, offsets, animation delay
 *
 */
/* eslint no-multi-str: "off" */ // - to allow multi-line strings for some path definitions

import Raphael from 'raphael';
import { getColorContrastsByMode } from '../../utils/Util';

export const wrapDynplotUtil = function(Dyn) {

Dyn.plotStrings = {
	// shared, translated strings used by plots; translate with Dyn.loc()
	promptX: "(drag and drop X attribute here)",
	promptY: "(drag and drop Y attribute here)",
    promptY2: "(drag and drop Y2 attribute here)",
	promptMapX: "(drag and drop longitude attribute here)",
	promptMapY: "(drag and drop latitude attribute here)",
	promptLegend: "(drag and drop Color By attribute here)",
    promptGroup: "(drag and drop Categorical attribute here)",
    promptValue: "(drag and drop Numerical attribute here)",
    promptJr: "(drop an attribute here)",
};
Dyn.plotStrings.swapAxisPrompts = function( xAxisData, yAxisData, key ) {
    // swap these prompt strings if in the AxisView.save() data; subroutine for swapAxes()
    const promptX = Dyn.loc( Dyn.plotUtil.isTuvaJr() ? Dyn.plotStrings.promptJr : Dyn.plotStrings.promptX );
    const promptY = Dyn.loc( Dyn.plotUtil.isTuvaJr() ? Dyn.plotStrings.promptJr : Dyn.plotStrings.promptY );
    if( xAxisData[key] === promptX )
        xAxisData[key] = promptY;
    if( yAxisData[key] === promptY )
        yAxisData[key] = promptX;
};

Dyn.plotTitles = {
	MIXED_UP_CASES: "mixed up cases",
	SCATTER_PLOT: "Scatter plot",
	DOT_PLOT: "Dot plot",
    BUBBLE_CHART: "Bubble chart",
	LINE_GRAPH: "Line graph",
    LINE_GRAPH_WITH_CATEGORIES: "Line Graph with Categories",
	PIE_CHART: "Pie Chart",
	BAR_CHART_OF_FREQUENCIES: "Bar Chart of Frequencies",
    BAR_CHART_OF_VALUES: "Bar Chart of Values",
	BAR_CHART_OF_SUMS: "Bar Chart of Sums",
    BAR_CHART_OF_MEANS: "Bar Chart of Means",
    STRETCHED_BAR_CHART: "Stretched Bar Chart",
	FREQ_HISTOGRAM: "Frequency Histogram",
    REL_PROP_HISTOGRAM: "Relative Proportion Histogram",
    REL_PERC_HISTOGRAM: "Relative Percentage Histogram",
	BOX_PLOT: "Box Plot",
    BOX_PLOT_WITH_OUTLIERS: "Box Plot with Outliers",
    BOX_DOT_PLOT: "Box and Dot Plot",
	MAP_PLOT: "Map plot",
    MAP_AND_BUBBLE_PLOT: "Map and Bubble plot",
    MAP_AND_LINE_PLOT: "Map and Line plot",
};

Dyn.plotPrimaryTypeMap = {
    'controlsMixup': Dyn.plotTitles.MIXED_UP_CASES,
    'controlsDotPlot': Dyn.plotTitles.DOT_PLOT,
    'controlsLineGraphSingle': Dyn.plotTitles.LINE_GRAPH,
    'controlsLineAndCategoryGraph': Dyn.plotTitles.LINE_GRAPH_WITH_CATEGORIES,
    'controlsBarChartOfFreq': Dyn.plotTitles.BAR_CHART_OF_FREQUENCIES,
    'controlsBarChartOfValues': Dyn.plotTitles.BAR_CHART_OF_VALUES,
    'controlsBarChartOfSums': Dyn.plotTitles.BAR_CHART_OF_SUMS,
    'controlsBarChartOfMeans': Dyn.plotTitles.BAR_CHART_OF_MEANS,
    'controlsStretchedBarChart': Dyn.plotTitles.STRETCHED_BAR_CHART,
    'controlsFreqHistogram': Dyn.plotTitles.FREQ_HISTOGRAM,
    'controlsPropHistogram': Dyn.plotTitles.REL_PROP_HISTOGRAM,
    'controlsPercHistogram': Dyn.plotTitles.REL_PERC_HISTOGRAM,
	'controlsPieChart': Dyn.plotTitles.PIE_CHART,
	'controlsBoxOnlyPlot': Dyn.plotTitles.BOX_PLOT,
	'controlsBoxAndOutlierPlot': Dyn.plotTitles.BOX_PLOT_WITH_OUTLIERS,
	'controlsBoxAndDotPlot': Dyn.plotTitles.BOX_DOT_PLOT,
	'controlsMap': Dyn.plotTitles.MAP_PLOT
};


    class DropState {
        static isNotInDrop( dropState ) {
            return ! dropState;
        }
        static isInDrop( dropState ) {
            switch( dropState ) {
                case "isHighlight":
                case "isOverDrop":
                // case "isDropElsewhere":
                    return true;
                default:
                    return false;
            }
        }
        static isValid( dropState ) {
            return DropState.isInDrop( dropState ) || DropState.isNotInDrop( dropState );
        }
    }
    Dyn.DropState = DropState;

Dyn.plotThemeColors = {
    // theme name: { colorName1:color, colorName2:color, ... }
    tuva: {
        'kLegendOpacity': 0.8,   // not a color, but we include it here anyway, works fine.
        'statLabelOpacity': 0.9, // background rect opacity for visible labels on statistics
        'statLabelHoverBrightness': 0.75, // on hover, darken hue to 75% of stat line/label color
        'promptDropFillColor': '#EAEEFE',
        'promptDropStrokeColor': '#989DA3',
        'highlightDropFillColor': '#C9D5FC',
        'highlightDropStrokeColor': '#003F5C',
        'overDropFillColor': '#7A9EF9',
        'overDropStrokeColor': '#003F5C',
        'normalDropColor': '#ffffff',
        'warningDropFillColor': '#ffac00',
        'statLabelTextColor': '#fff',
        'titleColor': '#000',
        titleColorInverse: "#fff",
        titleSelectedColor: "#334",
        'kAxisLineColor': '#7c7c7f',
        'kBinLineColor': '#ddddff',
        'kAxisTickColor': '#7c7c7f',
        'kAxisTickMarkTextColor': '#000',
        axisGridColors: ['#A18BB6', '#A18BB6', '#ccb8d7'], // replaces kAxisOriginGridColor, kAxisMajorGridColor, kAxisMinorGridColor
        'axisMultiAttributeFillColor': '#eee',

        // CASE ICON
        'kCaseColor': '#689ffc',
        'kCaseActiveColor': '#ECB806',
        'kCaseMissingValueColor': '#c5cddb',
        'kCaseMissingAxisColor': '#c5cddb',
        'kCaseBorderColor': '#003F5C',
        'kCaseHoverBorderColor': '#003F5C',
        'kCaseInSampleColor': '#4ec3a1',
        'kCaseInDistributionColor': '#b56aff',

        // 'titleDimmedColor': '#ccc',
        'axisButtonUpColor': '#828890',
        'axisButtonDownColor': '#3d4146',
        axisButtonBgUpColor: '#eee',
        axisButtonBgDownColor:'#e9e3a2',
        'axisButtonOpacity': 0.8,
        'contextMenuIconUpColor': '#828890',
        'contextMenuIconDownColor': '#3d4146',
        'meanColor': '#287F86',
        'medianColor': '#5c48ca',
        'modeColor': '#D43D1C',
        'meanAvDevColor': '#AA00E3',
        'stDevColor': '#DB1A8B',
        'stdErrColor': '#C10000',
        'varianceColor': '#2478C6',
        'iqrColor': '#6D3916',
        'leastSquaresColor': '#1B5593', // issue #2712
        'dividerColor': '#a8a8a8',
        'toolTipBgColor': '#5e5e5e',
        'tollTipTextColor': '#fff',
        'lineGraphStroke': '#555',
        'boxPlotStroke': '#555',
        'boxPlotFill': '#111',
        'mapButtonHover': '#ddd',
        'mapButtonNormal': '#fff',
        'histogramStroke': '#555',
        'freehandGlowColor': '#777',
        'handleUpColor': '#666',
        'handleDownColor': '#30AEBB',
        'textAnnotationBackgroundColor': '#efefef',
    },
    // 'yellow-on-blue': {
    //     'promptDropFillColor': '#2257f1',
    //     'overDropFillColor': '#3277ff',
    //     'normalDropColor': '#039',
    //     'legendOpacity': 0.3,
    //     'statLabelOpacity': 0.5,
    // },
    // 'black-on-rose': {
    //     'promptDropFillColor': '#ffb0ff',
    //     'overDropFillColor': '#ee90ee',
    //     'normalDropColor': '#ffd0ff',
    //     'legendOpacity': 0.4,
    //     'statLabelOpacity': 0.6,
    // },
    'reverse-contrast': {
        'kLegendOpacity': 0.5,
        'statLabelOpacity': 0.9,
        'statLabelHoverBrightness': 1.25, // on hover, lighten to 125% of stat line/label color
        'promptDropFillColor': '#190e07',
        'promptDropStrokeColor': '#857965',
        'highlightDropFillColor': '#120d08',
        'highlightDropStrokeColor': '#857965',
        'overDropFillColor': '#2b2019',
        'overDropStrokeColor': '#857965',
        'normalDropColor': '#000000',
        'warningDropFillColor': '#0053ff',
        'statLabelTextColor': '#000000',
        'titleColor': '#fff',
        titleColorInverse: "#000",
        titleSelectedColor: "#bba",
        'kAxisLineColor': '#838380',
        'kBinLineColor': '#222200',
        'kAxisTickColor': '#838380',
        'kAxisTickMarkTextColor': '#ffffff',
        axisGridColors: ['#9a87a9', '#9a87a9', '#64576b'],
        'axisMultiAttributeFillColor': '#111111',

        // CASE ICON
        'kCaseColor': '#976003',
        'kCaseActiveColor': '#1347f9',
        'kCaseMissingValueColor': '#3a3224',
        'kCaseMissingAxisColor': '#3a3224',
        'kCaseBorderColor': '#ffc0a3',
        'kCaseHoverBorderColor': '#ffc0a3',
        'kCaseInSampleColor': '#b13c5e',
        'kCaseInDistributionColor': '#4a9500',

        // 'titleDimmedColor': '#333333',
        'axisButtonUpColor': '#7d776f',
        'axisButtonDownColor': '#3d3936',
        'axisButtonBgUpColor': '#fcfbfa',
        axisButtonBgDownColor:'#ffffff',
        'axisButtonOpacity': 0.8,
        'contextMenuIconUpColor': '#7d776f',
        'contextMenuIconDownColor': '#3d3936',
        'meanColor': '#03729d',
        'medianColor': '#725f34',
        'modeColor': '#18753c',
        'meanAvDevColor': '#55ff1c',
        'stDevColor': '#993d5a',
        'stdErrColor': '#327589',
        'varianceColor': '#5927ab',
        'iqrColor': '#1a3b6b',
        'leastSquaresColor': '#59350f',
        'dividerColor': '#575757',
        'toolTipBgColor': '#a1a1a1',
        'tollTipTextColor': '#000000',
        'lineGraphStroke': '#aaaaaa',
        'boxPlotStroke': '#aaaaaa',
        'boxPlotFill': '#eeeeee',
        'mapButtonHover': '#222222',
        'mapButtonNormal': '#000000',
        'histogramStroke': '#aaaaaa',
        'freehandGlowColor': '#888888',
        'handleUpColor': '#999999',
        'handleDownColor': '#cf5144',
        'textAnnotationBackgroundColor': '#efefef',
    },
    'tuva-junior': {
        'kLegendOpacity': 0.8,   // not a color, but we include it here anyway, works fine.
        'statLabelOpacity': 0.9, // background rect opacity for visible labels on statistics
        'statLabelHoverBrightness': 0.75, // on hover, darken hue to 75% of stat line/label color
        'promptDropFillColor': '#fae1ee',
        'promptDropStrokeColor': '#f6b6d6',
        'highlightDropFillColor': '#f6b6d6',
        'highlightDropStrokeColor': '#f02075',
        'overDropFillColor': '#f02075',
        'overDropStrokeColor': '#f02075',
        'normalDropColor': '#ffffff',
        'warningDropFillColor': '#ffac00',
        'statLabelTextColor': '#fff',
        'titleColor': '#000',
        titleColorInverse: "#fff",
        titleSelectedColor: "#334",
        'kAxisLineColor': '#7c7c7f',
        'kBinLineColor': '#ddddff',
        'kAxisTickColor': '#7c7c7f',
        'kAxisTickMarkTextColor': '#000',
        axisGridColors: ['#A18BB6', '#A18BB6', '#ccb8d7'],
        'axisMultiAttributeFillColor': '#eee',

        // CASE ICON
        'kCaseColor': '#689ffc',
        'kCaseActiveColor': '#ECB806',
        'kCaseMissingValueColor': '#c5cddb',
        'kCaseMissingAxisColor': '#c5cddb',
        'kCaseBorderColor': '#003F5C',
        'kCaseHoverBorderColor': '#003F5C',
        'kCaseInSampleColor': '#4ec3a1',
        'kCaseInDistributionColor': '#b56aff',

        // 'titleDimmedColor': '#ccc',
        'axisButtonUpColor': '#828890',
        'axisButtonDownColor': '#3d4146',
        axisButtonBgUpColor: '#eee',
        axisButtonBgDownColor:'#e9e3a2',
        'axisButtonOpacity': 0.8,
        'contextMenuIconUpColor': '#828890',
        'contextMenuIconDownColor': '#3d4146',
        'meanColor': '#287F86',
        'medianColor': '#5c48ca',
        'modeColor': '#D43D1C',
        'meanAvDevColor': '#AA00E3',
        'stDevColor': '#DB1A8B',
        'stdErrColor': '#C10000',
        'varianceColor': '#2478C6',
        'iqrColor': '#6D3916',
        'leastSquaresColor': '#1B5593', // issue #2712
        'dividerColor': '#a8a8a8',
        'toolTipBgColor': '#5e5e5e',
        'tollTipTextColor': '#fff',
        'lineGraphStroke': '#555',
        'boxPlotStroke': '#555',
        'boxPlotFill': '#111',
        'mapButtonHover': '#ddd',
        'mapButtonNormal': '#fff',
        'histogramStroke': '#555',
        'freehandGlowColor': '#777',
        'handleUpColor': '#666',
        'handleDownColor': '#30AEBB',
        'textAnnotationBackgroundColor': '#efefef',
    },
    defaultTheme: Dyn.preferences.getTheme(),
    themesToUnitTest: [ 'tuva', 'reverse-contrast', 'tuva-junior'],

    /**
     * Get the color string for the default theme.
     * @param colorName
     * @returns {*}
     */
    getDefault: function( colorName ) {
        return this[ this.defaultTheme ][ colorName ];
    },

    /**
     * Get the color string for the given theme, which check to make sure theme and color names are valid.
     * See also Dyn.plotUtil.setThemeColors()
     * @param themeName
     * @param colorName
     * @returns {* | undefined}
     */
    getThemeColor: function( themeName, colorName ) {
        var themeColorSet = this[themeName],
            themeColor    = themeColorSet ? themeColorSet[colorName] : undefined;
        Dyn.assert( themeColorSet, "getThemeColor: plotThemeColors["+ themeName +"] does not exist");
        Dyn.assert( themeColor, "getThemeColor: plotThemeColors["+ themeName +"]["+ colorName +"] does not exist");
        return( themeColor ? themeColor : this.getDefault( colorName ) );
    },

    testThemes: {
        // test themes for use while debugging; selected modifications of plotThemeColors.tuva, etc.
        // added to Accessibility > Color Contrast theme menu in plot
        // 'themeName.testName': { colorName1:color, colorName2:color, ... }
        'tuva.tuvaGrid': {
            axisGridStyle: '', // use axisGridColors from tuva theme
        },
        'tuva.grayGrid': {
            axisGridStyle: 'Gray', // use axisGridColorsGray
        },
        'tuva.lightGrid': { // colors from v3.0.0
            axisGridStyle: 'Light', // use axisGridColorsLight
        }
        // reverse-contrast.test: {
        //   kBinLineColor: '#fff',
        // }
    },

    isValidThemeValue: function(v) {
        // string (color string) or number or array of numbers or color strings are valid, else not.
        switch( typeof v ) {
            case 'number':
                return Number.isFinite( v );
            case 'string':
                return v.length > 0;
            default:
                if( Array.isArray(v))
                    return v.length > 0;
                else
                    return false;
        }
    },

    isSimilarThemeValue: function(a, b) {
        // compare values between different themes; we expect the same type
        let isSimilar = (typeof a === typeof b);
        if( isSimilar && Array.isArray(a)) {
            isSimilar = (a.length === b.length);
        }
        return isSimilar;
    },

    /**
     * unitTest()
     * @param unitTester {Dyn.UnitTester}
     */
    unitTest( unitTester ) {
        let themes = this.themesToUnitTest.map( t => {
            Dyn.assert( typeof Dyn.plotThemeColors[t]==='object', "missing theme:"+t );
            return ({
                theme: t,
                keys: Object.keys( Dyn.plotThemeColors[t] )
            });
        });

        // test each key in each theme
        themes.forEach( (theme, themeIndex) => {
            theme.keys.forEach( ( key ) => {
                // assert that each key in this theme has a number, string, or array value
                unitTester.test(
                    Dyn.plotThemeColors.isValidThemeValue( Dyn.plotThemeColors[theme.theme][key] ),
                    "plotThemeColors." + theme.theme + " parameter <" + key + "> not a valid number, string, or Array" );
                // assert that each key exists in Dyn.plotUtil
                unitTester.test(
                    Dyn.plotThemeColors.isValidThemeValue( Dyn.plotUtil[key]),
                    "plotThemeColors." + theme.theme + "." + key + " exists, but plotUtil."+key+" does not exist." );
                // if more than one theme exists
                const theme2Index = (themeIndex===0) ? themeIndex+1 : themeIndex-1, // index of one other theme
                    theme2 = themes[theme2Index];
                if( theme2 ) {
                    // assert that each key in this theme exists in the other themes.
                    unitTester.test(
                        theme2.keys.includes( key ),
                        "plotThemeColors." + theme.theme + "." + key + " exists, but plotThemeColors."+theme2.theme+"."+key+" does not exist." );
                    // assert that a corresponding keys in other themes are of the same type
                    unitTester.test(
                        Dyn.plotThemeColors.isSimilarThemeValue(
                            Dyn.plotThemeColors[theme.theme][key],
                            Dyn.plotThemeColors[theme2.theme][key]
                        ),
                        "plotThemeColors." + theme.theme + "." + key + " does not match type or length of plotThemeColors."+theme2.theme+"."+key );
                }
            });
        });
    }
};

Dyn.plotUtil = {
	// NOTE: don't place any string constants needing translation here, use Dyn.plotStrings instead.

	// font
    plotTitleFontFamily: "Source Sans Pro",
    // font
	kAxisFontFamily: "'Bitter', serif",

	// overall
	containerBackground : "#fff", // compare to style.css > .visualContainer.background
	transparentContainer : "transparent", // compare to style.css > .visualContainer.background
	opacityInvisibleButDraggable : 0.01, // mostly invisible, just enough opacity so we can drag it (opacity 0.0 is not draggable)
	plotOpacityInDrawMode: 0.5, // "onion skin" effect while drawing over plot

	// animation
	// 	times in milliseconds (MS, 1000 per second)
	noAnimationMs : 0, // no animation, jump to new position
    stdAnimationTimeMs : 1500, // standard animations
	quickAnimationTimeMs : 500, // for hover/color change animations with no icon movement
    mixupAnimationTimeMs : 2000, // mixup is slower
    stdAnimationEasing: "easeInOut",
	quickAnimationEasing: "easeIn",
    fadeInAnimationEasing: "easeIn", // for animations going from opacity 0 to 1
	mixupAnimationEasing: "backOut",
    stdIconsPerCycle: 100,      // standard number of icons per animation batch, to start
    mixupIconsPerCycle: 600,     // icons per cycle is faster in mixup
    maxIconCycleMultiplier: 10, // do no more than 10x work per chunk
    fastIconCycleMultiplier: 3, // if task is easy, do 3x work per chunk
    iconCycleExponent: 1.5,    // 1.0=no increase in icons per cycle, 2.0= double every cycle, etc.
    maxNumIconsToAnimate: 2999, // turn off animation if greater
    progressIndicatorDelayMS: 500, // show progress indicator if animation takes longer than this

	// Axis
	kAxisLineColor : Dyn.plotThemeColors.getDefault('kAxisLineColor'),
	kBinLineColor : Dyn.plotThemeColors.getDefault('kBinLineColor'),
    kAxisTickColor : Dyn.plotThemeColors.getDefault('kAxisTickColor'),
    kAxisTickMarkTextColor : Dyn.plotThemeColors.getDefault('kAxisTickMarkTextColor'),
    axisGridColors: Dyn.plotThemeColors.getDefault('axisGridColors'), // for axis grid lines at origin, major, and minor tick marks
    axisGridColorsGray: [ '#000', '#aaa', '#ddd'],
    axisGridColorsLight: [ "#bbbbff", "#eeeeff", "#ddffff" ],
    axisGridStyle: '', // optional grid color style, e.g., 'Gray' for axisGridColorsGray
    axisMultiAttributeFillColor : Dyn.plotThemeColors.getDefault('axisMultiAttributeFillColor'),  // fill of multi-attribute icon, if color in legend
    axisMultiAttributeIconSize : 0.6, // max icon size is 60% of text height of title
    axisTickMarkRadius: 2,
    axisGridStrokeWidth: [2, 1.5, 1], // width of axis grid lines: origin, major, minor
    axisGridDashArray: ['none', '3,2', '2,2'], // dash array of axis grid lines: origin, major, minor

    //overDropStrokeColor: "#6993cf",
    // CONSIDER just iterating over Dyn.plotThemeColors[default].* to get default values (make sure parameter names are identical first)
    promptDropFillColor:  Dyn.plotThemeColors.getDefault('promptDropFillColor'),
    promptDropStrokeColor:  Dyn.plotThemeColors.getDefault('promptDropStrokeColor'),
    overDropFillColor: Dyn.plotThemeColors.getDefault('overDropFillColor'),
    overDropStrokeColor:  Dyn.plotThemeColors.getDefault('overDropStrokeColor'),
    // dropElsewhereFillColor: Dyn.plotThemeColors.getDefault('dropElsewhereFillColor'),
    // dropElsewhereStrokeColor:  Dyn.plotThemeColors.getDefault('dropElsewhereStrokeColor'),
    highlightDropFillColor: Dyn.plotThemeColors.getDefault('highlightDropFillColor'),
    highlightDropStrokeColor: Dyn.plotThemeColors.getDefault('highlightDropStrokeColor'),
    normalDropColor:  Dyn.plotThemeColors.getDefault('normalDropColor'),
    warningDropFillColor:  Dyn.plotThemeColors.getDefault('warningDropFillColor'),

    // CASE ICON
    kCaseColor: Dyn.plotThemeColors.getDefault('kCaseColor'),
    kCaseActiveColor: Dyn.plotThemeColors.getDefault('kCaseActiveColor'),
    kCaseMissingValueColor: Dyn.plotThemeColors.getDefault('kCaseMissingValueColor'),
    kCaseMissingAxisColor: Dyn.plotThemeColors.getDefault('kCaseMissingAxisColor'),
    kCaseBorderColor: Dyn.plotThemeColors.getDefault('kCaseBorderColor'),
    kCaseHoverBorderColor: Dyn.plotThemeColors.getDefault('kCaseHoverBorderColor'),
    kCaseInSampleColor: Dyn.plotThemeColors.getDefault('kCaseInSampleColor'),
    kCaseInDistributionColor: Dyn.plotThemeColors.getDefault('kCaseInDistributionColor'),
    kCaseSubtleBorder: "#a9a9a9", // for slight contrast in between pie slice or bar section and white or black background

    promptDropRectStrokeWidth: 0.5,
    highlightDropRectStrokeWidth: 2,
    overDropRectStrokeWidth: 2,

    titleColor: Dyn.plotThemeColors.getDefault('titleColor'),
    titleColorInverse: Dyn.plotThemeColors.getDefault('titleColorInverse'),
    titleSelectedColor: Dyn.plotThemeColors.getDefault('titleSelectedColor'),
	// titleDimmedColor: Dyn.plotThemeColors.getDefault('titleDimmedColor'),
	kMaxAttributesOnAxis: 99, // arbitrary but avoids extreme plots that are slow to calculate.
	kMinAxisThickness : 30, // minimum thickness, for an axis with no title, ticks, etc.
	kGradientThickness: 30,
    kAxisMaxProportion : 0.3, // axis thickness should be no more than 30% of plot height/width.
    extraDropZoneWidth: 0.3, // 30% of width of normal drop zone in X, 30% of height in Y
	extraDropZoneThickness : 12,
	extraDropZoneSpacer : 6,
    dropGlowWidth : 15,
    dropExpandMin : 45, // expand axis drop zone to at least this width
	kAxisTitleMargin : 5, // extra space around each title

	axisButtonUpColor:  Dyn.plotThemeColors.getDefault('axisButtonUpColor'),
	axisButtonDownColor: Dyn.plotThemeColors.getDefault('axisButtonDownColor'), //teal: #30AEBB
    axisButtonBgUpColor: Dyn.plotThemeColors.getDefault('axisButtonBgUpColor'),
    axisButtonBgDownColor: Dyn.plotThemeColors.getDefault('axisButtonBgDownColor'),
    axisButtonOpacity: Dyn.plotThemeColors.getDefault('axisButtonOpacity'),
    axisButtonSpacing: 5, // 5px from one button to the next (4px between buttons)
    plotButtonSpacing: 4, // 4px from one button to the next (3px between buttons)
	kAxisTitleFontSize : 16,
    kPlotTitleFontSize : 16,
    plotTitlePencilSize : 14,
    plotTitleSoftResetIconSize : 14,
    kPlotSubtitleFontSize : 10,
    kAxisLabelFontSize : 12, // category names and numeric tick marks on axis
	kDeselectedCategoryOpacity : 0.4,
	kCalculatedAxisValueExtraPrecision : 2, // add 2 decimal places to calulated value displays like mean, median, boxplot q1, etc.
    extraMarginForCaseOutlines : 4, // should be >= kCaseIconBorderWidthSelected below

    // Legend
    kLegendStdThickness : 100,
    kLegendMaxProportion : 0.33, // legend should use no more than 33% of plot width
    kLegendCategoryHeight : 1.2, // 1.2 times the "X" height of the font
    //kLegendFill: Dyn.plotThemeColors.getDefault( 'normalDropColor' ), // removed, use Dyn.plotUtil.normalDropColor instead
    kLegendOpacity: Dyn.plotThemeColors.getDefault( 'kLegendOpacity' ), // fade background of legend (e.g. Map in background) so that legend text is more visible.

	// case icons
	kCaseIconBorderWidthSelected: 2,
    // excluded cases: missing and filtered cases display
	missingCasePosX : 5,  // where hidden cases animate from, in top-right of plot
	missingCasePosY : 15, // where hidden cases animation from, in top-right of plot
	missingCaseSize : 0,  // 0 = invisible circle in the final position, after animation
	excludedCasesFontSize : 10, // for count of missing/excluded cases
	excludedCasesTextOpacity: 0.8,
	missingCaseIconRadius: 4, // circle size next to count of missing cases.
	fileredCaseIconSize : 12, // correct size for filter symbol (only)
	//fileredCaseIconOffset : 2, // a little lower than the exact center

    // sonification
    sonifyBorderWidth: 5,

    // accessibility
    enableCaseTabOrder: true, // if true, do extra sorting of cases for correct tab order (use false to test performance)

	// adornments
    countTextColorDark: '#000000', // use black text on light colored Bar or Pie sections
    countTextColorLight: '#ffffff', // use white text on dark colored Bar or Pie sections
    caseBackgroundMinBrightness: 128, // [0-255] scale, if darker, use countTextColorLight
    caseBackgroundMinContrast: 32, // [0-255] scale, if less contrast, use contrasting border
    caseBackgroundBrightness: Dyn.colorUtil.getColorBrightness( Dyn.plotThemeColors.getDefault('normalDropColor')),
    meanColor: Dyn.plotThemeColors.getDefault('meanColor'),
	medianColor: Dyn.plotThemeColors.getDefault('medianColor'),
	modeColor: Dyn.plotThemeColors.getDefault('modeColor'),
    meanAvDevColor: Dyn.plotThemeColors.getDefault('meanAvDevColor'),
	stDevColor: Dyn.plotThemeColors.getDefault('stDevColor'),
    stdErrColor: Dyn.plotThemeColors.getDefault('stdErrColor'),
    varianceColor: Dyn.plotThemeColors.getDefault('varianceColor'),
    iqrColor: Dyn.plotThemeColors.getDefault('iqrColor'),
	leastSquaresColor: Dyn.plotThemeColors.getDefault('leastSquaresColor'),
	dividerColor: Dyn.plotThemeColors.getDefault('dividerColor'),
	transparentColor: "rgba(255, 255, 255, 0)",
	adornAnimationTimeMs: 1500,
	adornAnimationEasing: "easeInOut",
    textAdornAnimationTimeMs: 2000,
    textAdornAnimationEasing: "easeIn",
	toolTipAnimationTimeMs: 100,
	toolTipBgColor: Dyn.plotThemeColors.getDefault('toolTipBgColor'),
	tollTipTextColor: Dyn.plotThemeColors.getDefault('tollTipTextColor'),
	glowWidth: 10,
	lineGlowWidth: 5,
	lineCoverWidth: 8,  // see also refLineCoverWidth, dividerLineCoverWidth
    populationAverageWidth: 2,
    opacityOfStDevVarianceIqrRect: 0.2,
    stdErrorCrossBarSize: 2.0, // 2.0 times Dyn.preferences.getFontSize()
    stdErrorBarWidth: 0.5, // 0.5 times Dyn.preferences.getFontSize()
    stdErrorCellPosition: 0.5,  // 0.5 of way from axis to top of plot area
    labelConnectorLineSpacer: 5, // 5 pixels between connector line and object it is connecting
    stdDevDashArray: '6,4', // dashed line in Std Deviation to mark mean line (SVG stroke-dasharray)
    showSquaresDashArray: '1,4', // dashed line in Movable line with Show Squares

    // Labels for Statistics (mean, median, etc), and Movable Line and Least Squares Line
    statLabelOpacity: Dyn.plotThemeColors.getDefault( 'statLabelOpacity' ),
    statLabelTextColor: Dyn.plotThemeColors.getDefault( 'statLabelTextColor' ),
    statLabelHoverBrightness: Dyn.plotThemeColors.getDefault( 'statLabelHoverBrightness' ),
    statLabelBorderDx: 7, // 7px expanded stat label rect on X
    statLabelBorderDy: 4, // 4px expanded stat label rect on Y
    statLabelRoundRectRadius: 3,
    statLabelConnectorLineWidth: 0.5,
    statLabelFontFamily: 'Source Sans Pro',

    // for plot function paths
    functionCurveColors: [
        '#2a70ff', '#4dc00e','#ff51af',
        '#a369e1', '#d58f00',  '#777777',
        '#3fe4e0','#b2df8a', '#fb9a99',
        '#cab2d6', '#c01b1f', '#bbbbbb' ],
    functionCurveWidth: 2,
    functionCoverWidth: 10,
    functionGlowWidth: 5,
    functionPointRadius: 4,
    //functionPointColor: "#aaa",
    functionSnapDist: 2, // show value of nearest tickmark in X if this close
    functionFastAnimationTimeMs: 100, // after updating sliders
    fxMinAngle: 0.4 * Math.PI*2/360, // at least 0.4 degree angle OK
    fxMaxAngle: 0.8 * Math.PI*2/360, // more than 0.8 degrees angle not OK
    fxInitialDeltaViewX: 3, // evaluate function every 3 pixels along x axis
    fxMinDeltaViewX: 0.1, // move at least one pixel along curve for each point.
    fxMaxDeltaViewX: 25,  // max 25 pixels between points on curve
    fxDiscontinuityAngle: 1.0, // if angle between points more than 1 radian, treat as a discontinuity

	// dot plots
	stackMargin: 5,

	// line graph / boxplot / map
	circleWithLinesSizeFraction: 0.6, // [0-1] circles shrink this much in Line Plot (fraction of case icon size)
    circleOnMapSizeFraction: 0.7, // [0-1] circles shrink this much in Map Plot
    bubblePlotSizeFraction: 2.0, // [1+] max bubble size expands this much in Bubble Plot
    bubbleOnMapSizeFraction: 1.5, // [1+] max bubble-on-map size expands in Map and Bubble Plot
	lineGraphStroke: Dyn.plotThemeColors.getDefault('lineGraphStroke'),
	lineGraphWidth: 2,
	boxHeight: 0.5, // [0-1] fraction of available space
	boxPlotStroke: Dyn.plotThemeColors.getDefault('boxPlotStroke'),
	boxPlotWidth: 2,
	boxPlotFill: Dyn.plotThemeColors.getDefault('boxPlotFill'),
	boxPlotFillOpacity: 0.1,
    mapButtonleft: 12,
    mapOrFxButtonTop: 12, // top of F(x) buttons, in same position as Leafet-created zoom buttons
    mapDragButtonTop: 83, // top of drag-map button, below Leaflet-created Zoom +/- buttons
    mapButtonSpacer: 4,
    mapButtonWidth: 31,
    mapButtonRadius: 3,
    mapButtonBottom: 160, // 188 = 83 + (3*(31+4)) (top + 3*(spacer+width)) for 3 buttons
    mapButtonHover: Dyn.plotThemeColors.getDefault('mapButtonHover'),
    mapButtonNormal: Dyn.plotThemeColors.getDefault('mapButtonNormal'),
    histogramStroke: Dyn.plotThemeColors.getDefault('histogramStroke'), // compare to boxPlotStroke
    histogramWidth: 2, // outline stroke is max of 2 pixels wide
    histogramMaxStrokeToBarWidth: 0.25, // but no more that 25% of bar width if narrow bars

	// histograms and attribute type 'Categorical:Numeric Intervals'
	kStartingNumIntervals : 5,
	kMinNumIntervals : 2,
	kMaxNumIntervals : 1000, // arbitrary, about 1 per case for a large dataset, or 1 bin every 4 pixels on a large display

	// reflines (on X or Y)
	refLineWidth: 2,
    refLineCoverWidth: 8, // also used for divider line width
    refLineSnapDistance: 2,
    refLineDualAxisOffset: 20, // if dual axis plot, move Y1 lines away from Y2 axis, and move Y2 lines away from Y1 axis
    refLineColors: [
        // source: https://colorbrewer2.org/?type=qualitative&scheme=Set1&n=9j
        // plus 3 from: https://colorbrewer2.org/?type=qualitative&scheme=Pastel1&n=9
        '#777777','#377eb8', '#4daf4a',
        '#984ea3', '#d7060a','#c09410',
        '#bbbbbb', '#b3cde3','#ccebc5',
        '#f781bf','#ff7f00','#e5d8bd'],

    // dividers
    dividerLineWidth: 3,
    dividerLineCoverWidth: 10, // must be larger than refLineCoverWidth or lineCoverWidth

    // rulers
    rulerLineWidth: 1,
    rulerLineDashArray: '2,2',
    rulerArrowOpacity: 0.8, // 50% opacity for ruler arrow

    // movable line (aka diagonal line on X-Y)
	//movableLineEndpointStroke: "#666",
	movableLineEndpointRadius: 4,
	movableLineEndpointWidth: 2,
    movableLineSnapDist: 4,
    //movableLineSlopePrecision: 5,
    // movableLineColors: Dyn.plotThemeColors.getDefault('movableLineColors'),
    // movableLineColorsY2: Dyn.plotThemeColors.getDefault('movableLineColorsY2'),
    showSquaresLineWidth: 1, // 0.5 nice but too thin

	// annotation tools
    annotationLineWidthDefault: 4,
    annotationLineWidthMax: 8,
    annotationLineSnapDist: 4,
	annotationColors: [
            // source: #777777 + https://colorbrewer2.org/?type=qualitative&scheme=Paired&n=11
            '#777777', '#a6cee3','#1f78b4','#b2df8a','#33a02c', // first color is default for new annotations
            '#fb9a99','#e31a1c','#fdbf6f','#ff7f00',
            '#cab2d6','#6a3d9a','#ffff99'],
    pencilLineMinPixels: 4, // minimum pixels distance between points
    pencilSmoothingMin: 0, // 0=no smoothing, 1+= smoothing, -1=show mouse points
    pencilSmoothingMax: 9, // arbitrary, could be larger
    pencilSmoothingDefault: 3,
    pencilMinFillDist: 5, // only allow fill if at least 5 pixels per dimention, so object is visible w/o outline
    textAnnotationColors: [
            // text foreground/background colors for annotations don't change when changing to reverse contrast theme,
            // so we want to allow user to pick both light-on-dark, and dark-on-light colors in either theme.
            // so we list them here for re-use as either the foreground or background color.
            '#9f9f9f', '#695c78', '#000000',
            '#1007dc', '#007c7f', '#f2503b',  // dark colors
            '#eceef0', '#ddded9', '#F8F8F8',
            '#f5ae03', '#bbd445', '#eddacc'], // corresponding light colors
	freehandGlowWidth: 5,
	freehandGlowColor: Dyn.plotThemeColors.getDefault('freehandGlowColor'),
    handleUpColor: Dyn.plotThemeColors.getDefault('handleUpColor'),
    handleDownColor: Dyn.plotThemeColors.getDefault('handleDownColor'), //teal: #30AEBB
    arrowAnnotationLength: 20,
    arrowAnnotationWidth: 10,
    textAnnotationSizeMin: 8, // minimum font size
    textAnnotationSizeMax: 80, // maximum font size
    textAnnotationSizeDefault: 15, // default font size
    textAnnotationBorderDx: 7,
    textAnnotationBorderDy: 7,
    textAnnotationBackgroundColor: Dyn.plotThemeColors.getDefault('textAnnotationBackgroundColor'),
    resizeHandleSize: 10,

    // on print, preview, readonly, use the class to hide the element
    hideOnPreviewClass: "no-print",
    xAxisCloseButtonId: "tde-id-xaxis-close-button",
    yAxisCloseButtonId: "tde-id-yaxis-close-button",
    yAxisCloseButtonRightId: "tde-id-yaxis-close-right-button", // TODO use for Y2 axis? Was used for color legend close box
    colorLegendViewCloseButtonId: "tde-id-legend-close-button", // TODO rename to "tde-id-color-legend-close-button"?
    bubbleLegendViewCloseButtonId: "tde-id-bubble-legend-close-button",
    plotTitleCloseButtonId: "tde-id-plot-title-close-button",
    orderByCloseButtonId: "tde-id-order-by-close-button",
    orderByViewAreaId: "tde-id-order-view-area",
    bubbleViewAreaId: "tde-id-bubble-view-area",
    xAxisDropAreaId: "tde-id-xaxis-drop-area",
    yAxisDropAreaId: "tde-id-yaxis-drop-area",
    xAxisExtraDropAreaId: "tde-id-xaxis-extra-area",
    yAxisExtraDropAreaId: "tde-id-yaxis-extra-area",
    legendViewAreaId: "tde-id-legend-view-area",
    xAxisPlusButtonId: "tde-id-xaxis-plus-button",
    yAxisPlusButtonId: "tde-id-yaxis-plus-button",
    legendPlusButtonId: "tde-id-legend-plus-button",
    xAxisMinusButtonId: "tde-id-xaxis-minus-button",
    yAxisMinusButtonId: "tde-id-yaxis-minus-button",
    legendMinusButtonId: "tde-id-legend-minus-button",
    xAxisDragMiddleButtonId: "tde-id-xaxis-drag-middle-button",
    yAxisDragMiddleButtonId: "tde-id-yaxis-drag-middle-button",
    xAxisDragMinButtonId: "tde-id-xaxis-drag-min-button",
    yAxisDragMinButtonId: "tde-id-yaxis-drag-min-button",
    xAxisDragMaxButtonId: "tde-id-xaxis-drag-max-button",
    yAxisDragMaxButtonId: "tde-id-yaxis-drag-max-button",
    xAxisSettingsButtonId: "tde-id-xaxis-settings-button",
    yAxisSettingsButtonId: "tde-id-yaxis-settings-button",
    axisSwapButtonId: "tde-id-swap-axis-button",
    stdSettingsButtonId: "tde-id-std-settings-button",
    annotateContextMenuID: "tde-id-annotate-menu-button",
    histogramContextMenuID: "tde-id-histogram-menu-button",
    mapPlotContextMenuID: "tde-id-map-plot-menu-button",
    refLineContextMenuID: "tde-id-ref-line-menu-button",
    refDiagContextMenuID: "tde-id-ref-diag-menu-button",
    leastSquareContextMenuID: "tde-id-least-square-menu-button",
    rulerContextMenuID: "tde-id-ruler-menu-button",
    rulerCloseButtonId: "tde-id-ruler-close-button",
    plotTitleId: "tde-id-plot-title",
    plotSubTitleId: "tde-id-plot-subtitle",
    editPlotTitleButtonId: "tde-id-edit-title-button",
    softResetTitleButtonId: "tde-id-soft-reset-button",

	// cursor
	// 		standard and custom cursor reference:  https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
	cursorMove: "move",
	cursorPointer: "pointer",
	cursorDefault: "default",
	cursorCrossHair: "crosshair",
	cursorHorizontalBothSide: "ew-resize",
	cursorVerticalBothSide: "ns-resize",
    cursorPencil: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABP0lEQVRIS9XVr0oFQRiG8d9JgmDUCzAYBA0mQfAGrCb/gMFmNJkUxOA9qEkRFMViFLwCi2AzCWI3iEVlYBeGcY6zu3qCG3dnnueb95uZ7Rnw0xsw318IhvDer9DfCAL4ACvYwj4+U1FXwTDOsBABd7GdSroKlnGciSVIdvBRf2srCLHc4BoTWMtIlnDaRRDgF1Esm5jKSNZx2FZQw+cxElWdSl4xi4c2ghz8DjMVJJZM4z6OrdSDErxmbeASL222aVN4YH6rvBRRU3jIfC6NpRRRulvC+Djzen4RHgamPcid0LAjJpNsG8FzgnBIThAAbxjLHKTG8JxgEUfVKQ035G3VwFax/NSDIDivBqziqlpNeNWq8n67KBaElTxirys8F1HuluxUeb8VjGI8aewznvr9sUrvS1dFaX7x+/8XfAGUC0QZcJjk1QAAAABJRU5ErkJggg==) 3 29, auto", // glyphicons pencil
    cursorHand: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACC0lEQVRIS7XVScjNYRTH8c8rs4iShSwUMiRjspAhUyEyJRYslJWslNiYNqayEBvDThLJwo4MsSJDFhZkWNgIJdnJ1Knzf7uu+z73f8mzuYv7/M/3nPP7nfN0+c+nq4P4c7EUn3EVr+p8WwcwEstxpyngPDzH+xKoBBiK65iVASLQRozF6YagB3EAP1qBSoBD2I0bGIiPWIN+eIa7WdkILMKtTgGnsArjEYlcwQr0x2HswDQ8wWssyd/fOKUKTmA0VmMALmMlBmEDzmIcXjREPIo9je36W8BmRIUBeIS92IZJWdXTCvqvgInZxiOYjztpioclwBB8xUmEgK1aVFXQCBiDlyXAcFxIsaoELmFTahDDtSw1qACTU5dwXKVH2PqPCnqlHRfiCwYn4VpW8BNbcD5dFGJfxLBMKBIpAsIZD3L81yKG7H5mEhW0HKIm39cCvMmMv2F6ZjwF32vsnaIG0aKbWICdOJ4BZ+QgRYvancXZ5pYaxMcxVFFBnFhk99pFbPp/K85hJh73ZNMqi1hsU/GuA0gM3npMwKfSHOzHPoSDQvDQo92J/RSmiLcinNj9TatJ7oPbmNOkRwkSM/QBx7Cr8WJPq2IU3ubF8HwAe7cghLv6Yl2+EbGPYgl2n9IuqvRo157G/8OqsbprAeLSbGzPR6YEit7HK9e9Ikoid5Jx27t1Hv22QUoXfgEkpXEZAUhckQAAAABJRU5ErkJggg==) 16 16, auto", // glyphicons pencil
    cursorDisabled: 'not-allowed',

    // Browser detection utilities
    isSafari: function() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },

    // Menu
    contextMenuIconDownColor: Dyn.plotThemeColors.getDefault('contextMenuIconDownColor'),
    contextMenuIconUpColor: Dyn.plotThemeColors.getDefault('contextMenuIconUpColor'),
    contextMenuSize: 18, // size of context menu icon in plot
    contextMenuRadius: 4, // round-rect radius of white clickable background
	// icons for UI controls
	iconSize: 20,
	// 'x' icon source: http://raphaeljs.com/icons/#cross
	iconX: "M24.778,21.419 19.276,15.917 24.777,10.415 21.949,7.585 16.447,13.087 10.945,7.585 8.117,10.415 13.618,15.917 8.116,21.419 10.946,24.248 16.447,18.746 21.948,24.248z",
	// '+' icon source: http://raphaeljs.com/icons/#plus
	iconPlus: "M25.979,12.896 19.312,12.896 19.312,6.229 12.647,6.229 12.647,12.896 5.979,12.896 5.979,19.562 12.647,19.562 12.647,26.229 19.312,26.229 19.312,19.562 25.979,19.562z",
	// '-' icon source: http://raphaeljs.com/icons/#minus
	iconMinus: "M25.979,12.896,5.979,12.896,5.979,19.562,25.979,19.562z",
    // settings icon - source: https://github.com/TuvaLabs/tuva-icons/blob/master/svgs/settings.svg
    iconSettings: "m16,9.077l0,-2.154c-1.1,-0.392 -1.8,-0.5 -2.146,-1.346l0,0c-0.352,-0.847 0.066,-1.423 0.564,-2.471l-1.518,-1.525c-1.04,0.495 -1.622,0.917 -2.471,0.565l0,0c-0.852,-0.346 -0.962,-1.051 -1.352,-2.146l-2.154,0c-0.388,1.09 -0.5,1.795 -1.346,2.146l0,0c-0.849,0.354 -1.422,-0.066 -2.477,-0.565l-1.519,1.519c0.5,1.045 0.916,1.623 0.565,2.471l0,0c-0.351,0.847 -1.056,0.958 -2.146,1.346l0,2.155c1.088,0.387 1.795,0.5 2.146,1.346l0,0c0.354,0.855 -0.076,1.444 -0.565,2.471l1.519,1.53c1.042,-0.495 1.622,-0.917 2.471,-0.564l0,0c0.846,0.351 0.957,1.053 1.346,2.146l2.155,0c0.388,-1.09 0.5,-1.794 1.351,-2.148l0,0c0.841,-0.35 1.413,0.067 2.466,0.567l1.53,-1.52c-0.5,-1.043 -0.917,-1.622 -0.565,-2.471s1.057,-0.964 2.146,-1.352zm-8,1.59a2.667,2.667 0 1 1 2.667,-2.667a2.667,2.667 0 0 1 -2.667,2.667z",
    // "o" missing value icon
	iconMissingValue: "M16,1.466C7.973,1.466,1.466,7.973,1.466,16c0,8.027,6.507,14.534,14.534,14.534c8.027,0,14.534-6.507,14.534-14.534C30.534,7.973,24.027,1.466,16,1.466zM16,29.534C8.539,29.534,2.466,23.462,2.466,16C2.466,8.539,8.539,2.466,16,2.466c7.462,0,13.535,6.072,13.535,13.533C29.534,23.462,23.462,29.534,16,29.534z",
	// "Y" filter icon, drawn by Ben to be similar to class="glyphicon glyphicon-filter" included with bootstrap.js
	//        x = 216, y = 172, w = 138, h = 168; desiredHeight = 10
	iconFilter: "M216,172 h138 v14 h-138z M223,200 271.4,270 271,270 271,338.7 299,311 299,311 299,270 299,270 347,200z",
	// swap axes icon
	iconSwap1:
			"M20,18.129c0,0-10.742,0-11.3,0c-4.101,0-4.3-0.132-4.3-4.187c0-1.489,0-9.535,0-9.535h2.715L3.558,0L0,4.407h2.6c0,0,0,10.704,0,11.337C2.6,19.66,3.3,20,7.133,20C7.725,20,20,20,20,20V18.129z",
	iconSwap2:
			"M10.761,0.082c0,0,0,5.325,0,5.905c0,5.322,0.399,6.154,3.047,6.154c1.433,0,1.953,0,1.953,0V9.297L20,12.996l-4.239,3.697v-2.682c0,0-3.078,0-3.687,0c-2.547,0-3.114-1.005-3.114-6.396c0-0.615,0-7.534,0-7.534H10.761z",
    iconAxisLeft:
        "M-3,-3 L-5,-3 -5,3 -3,3 -3,1 5,1 5,-1 -3,-1z",
    iconAxisRight:
        "M12,-3 L12,-1 4,-1 4,1 12,1 12,3 14,3 14,-3z",
    iconRangeHorzontal:
        "M22.557,3.083 L12.045,3.083 12.045,1 7.325,4 12.045,7 12.045,4.917 22.557,4.917 22.557,7 27.277,4 22.557,1z",
    iconDragHand:
        "M10.464,18.064c0-0.324,0-0.551,0-0.78c0-2.584-0.01-5.168,0.002-7.752c0.014-2.97,2.234-5.039,5.204-4.895\
 c0.197,0.009,0.485-0.131,0.594-0.293c2.044-3.041,6.198-3.051,8.228-0.017c0.104,0.157,0.357,0.333,0.521,0.316\
 c3.082-0.32,5.436,2.303,5.299,4.804c-0.004,0.08,0.031,0.164,0.03,0.158c0.83,0.219,1.656,0.313,2.371,0.648\
 c1.757,0.821,2.698,2.258,2.71,4.217c0.023,3.375,0.123,6.755-0.037,10.12c-0.099,2.051-0.613,4.083-0.962,6.12\
 c-0.2,1.177-0.43,2.351-0.669,3.521c-0.464,2.27-2.15,3.672-4.479,3.701c-1.858,0.022-3.717,0.004-5.574,0.004\
 c-2.542,0-5.083-0.02-7.624,0.006c-2.073,0.021-3.686-0.76-4.926-2.457c-2.382-3.258-4.84-6.457-7.249-9.693\
 c-1.647-2.214-1.52-4.822,0.294-6.783c1.337-1.444,3.676-1.971,5.545-1.247C9.943,17.839,10.138,17.927,10.464,18.064z\
  M22.643,19.917c0-0.293,0-0.568,0-0.842c0-3.995,0.002-7.989,0-11.984c-0.002-1.464-0.944-2.486-2.271-2.476\
 c-1.328,0.011-2.24,1.027-2.244,2.503c-0.002,0.427-0.001,0.854-0.001,1.282c0.001,3.653,0.001,7.305,0,10.958\
 c0,0.356,0.071,0.792-0.612,0.548c0-0.24,0-0.491,0-0.743c0-3.204,0.003-6.409-0.002-9.612c-0.002-1.112-0.667-2.032-1.613-2.273\
 c-1.58-0.4-2.896,0.642-2.898,2.316C12.996,14.443,13,19.292,13,24.141c0,0.239,0,0.479,0,0.717\
 c-0.272-0.15-0.408-0.31-0.534-0.477c-0.847-1.126-1.678-2.265-2.542-3.378c-1.13-1.458-3.243-1.337-4.227,0.222\
 c-0.598,0.947-0.519,1.992,0.259,3.034c2.467,3.302,4.954,6.589,7.409,9.899c0.627,0.845,1.41,1.248,2.457,1.232\
 c1.581-0.022,3.162-0.006,4.743-0.006c2.84,0,5.683,0.006,8.522-0.002c1.306-0.004,1.976-0.566,2.22-1.832\
 c0.235-1.215,0.487-2.427,0.693-3.646c0.316-1.871,0.771-3.739,0.855-5.622c0.143-3.177,0.043-6.364,0.039-9.546\
 c-0.002-1.416-0.947-2.427-2.252-2.43c-1.304-0.003-2.256,1.01-2.26,2.422c-0.006,1.516,0,3.033-0.003,4.549\
 c-0.001,0.227-0.024,0.452-0.034,0.654c-0.656,0.189-0.576-0.227-0.576-0.561c-0.002-3.268,0.006-6.536-0.004-9.805\
 c-0.004-1.665-1.348-2.702-2.923-2.284c-0.934,0.249-1.586,1.178-1.587,2.295c-0.005,3.268-0.001,6.536-0.001,9.804\
 C23.255,19.726,23.314,20.125,22.643,19.917z",
    iconMarqueeRectangle:
        "M23.792,2.5h-7.983c-0.477,0-0.863,0.523-0.863,1s0.387,1,0.863,1h7.983c0.477,0,0.863-0.523,0.863-1 \
	   S24.269,2.5,23.792,2.5z \
	 M10.847,2.5H2.863C2.386,2.5,2,2.886,2,3.363v7.983c0,0.477,0.523,0.863,1,0.863s1-0.386,1-0.863V4.5h6.847 \
	   c0.477,0,0.863-0.523,0.863-1S11.323,2.5,10.847,2.5z \
	 M23.792,36.5h-7.983c-0.477,0-0.863,0.523-0.863,1s0.387,1,0.863,1h7.983c0.477,0,0.863-0.523,0.863-1 \
			S24.269,36.5,23.792,36.5z \
	 M10.847,36.5H4v-7.245c0-0.477-0.523-0.863-1-0.863s-1,0.386-1,0.863v7.983C2,37.715,2.386,38.5,2.863,38.5h7.983 \
			c0.477,0,0.863-0.523,0.863-1S11.323,36.5,10.847,36.5z \
	 M3,25.155c0.477,0,1-0.386,1-0.863v-7.983c0-0.477-0.523-0.863-1-0.863s-1,0.387-1,0.863v7.983 \
			C2,24.769,2.523,25.155,3,25.155z \
	 M37,15.446c-0.477,0-1,0.387-1,0.863v7.983c0,0.477,0.523,0.863,1,0.863s1-0.386,1-0.863v-7.983 \
			C38,15.833,37.477,15.446,37,15.446z \
	 M37,28.392c-0.477,0-1,0.386-1,0.863V36.5h-7.245c-0.477,0-0.863,0.523-0.863,1s0.386,1,0.863,1h7.983 \
			c0.477,0,1.262-0.785,1.262-1.262v-7.983C38,28.778,37.477,28.392,37,28.392z \
	 M36.738,2.5h-7.983c-0.477,0-0.863,0.523-0.863,1s0.386,1,0.863,1H36v6.847c0,0.477,0.523,0.863,1,0.863s1-0.386,1-0.863 \
			V3.363C38,2.886,37.215,2.5,36.738,2.5z",
    // iconResetView: "M22.557,3.083 L12.045,3.083 12.045,1 7.325,4 12.045,7 12.045,4.917 22.557,4.917 22.557,7 27.277,4 22.557,1z",
    iconFitIcon1: "M6.4 4.03L3.34 0L0.27 4.03L2.41 4.03L2.41 13.97L0.27 13.97L3.34 18L6.4 13.97L4.27 13.97L4.27 4.03L6.4 4.03Z ",
	iconFitIcon2: "M9.75 15.21C9.09 15.21 8.58 15.02 8.07 14.61C8.15 14.48 8.74 13.46 8.82 13.33C9.09 13.56 9.34 13.67 9.62 13.67C9.99 13.67 10.27 13.48 10.44 13.11C10.45 13.09 10.51 12.98 10.61 12.77L8.05 6.71L9.88 6.71L11.5 10.96L12.96 6.71L14.73 6.71L12.02 13.58C11.22 14.67 10.46 15.21 9.75 15.21Z",
    iconResetView: "M 25 1.0507812 C 24.7825 1.0507812 24.565859 1.1197656 24.380859 1.2597656 L 1.3808594 19.210938 C 0.95085938 19.550938 0.8709375 20.179141 1.2109375 20.619141 C 1.5509375 21.049141 2.1791406 21.129062 2.6191406 20.789062 L 4 19.710938 L 4 46 C 4 46.55 4.45 47 5 47 L 19 47 L 19 29 L 31 29 L 31 47 L 45 47 C 45.55 47 46 46.55 46 46 L 46 19.710938 L 47.380859 20.789062 C 47.570859 20.929063 47.78 21 48 21 C 48.3 21 48.589063 20.869141 48.789062 20.619141 C 49.129063 20.179141 49.049141 19.550938 48.619141 19.210938 L 25.619141 1.2597656 C 25.434141 1.1197656 25.2175 1.0507812 25 1.0507812 z M 35 5 L 35 6.0507812 L 41 10.730469 L 41 5 L 35 5 z",
    iconPencil: "M10.8351 0.50411C11.1579 0.181328 11.5958 0 12.0524 0C12.5089 0 12.9468 0.181328 13.2696 0.50411L15.4959 2.73035C15.8187 3.05323 16 3.49109 16 3.94764C16 4.40419 15.8187 4.84205 15.4959 5.16493L14.1305 6.53029L9.46971 1.86947L10.8351 0.50411ZM8.25242 3.08676L0.504477 10.8347C0.181561 11.1575 9.75163e-05 11.5954 0 12.052V14.2782C0 14.7349 0.1814 15.1728 0.504293 15.4957C0.827187 15.8186 1.26512 16 1.72177 16H3.94801C4.40461 15.9999 4.84248 15.8184 5.1653 15.4955L12.9132 7.74758L8.25242 3.08676Z",
    // iconSoftReset: "M8 0C12.4112 0 16 3.58885 16 8C16 12.4112 12.4112 16 8 16C3.58885 16 0 12.4112 0 8C0 3.58885 3.58885 0 8 0ZM3.38461 7.33731H6.80769L5.38923 5.91885L5.60462 5.66846C5.98988 5.26851 6.46824 4.97025 6.99695 4.80036C7.52565 4.63047 8.08822 4.59424 8.63435 4.69492C9.18047 4.79559 9.69315 5.03003 10.1265 5.37726C10.5599 5.7245 10.9005 6.17372 11.1178 6.68476C11.3351 7.1958 11.4224 7.75272 11.3719 8.30575C11.3214 8.85878 11.1346 9.39067 10.8283 9.85387C10.522 10.3171 10.1056 10.6971 9.6165 10.9601C9.12738 11.2231 8.58071 11.3607 8.02538 11.3608C7.33039 11.3601 6.65262 11.1444 6.08507 10.7433C5.51751 10.3422 5.08797 9.7753 4.85538 9.12039L4.64885 8.53846L3.48846 8.94885L3.69231 9.53077C3.97279 10.3246 4.46609 11.026 5.11828 11.5583C5.77047 12.0907 6.55645 12.4335 7.39033 12.5494C8.22421 12.6652 9.07388 12.5496 9.84649 12.2152C10.6191 11.8808 11.2849 11.3404 11.7712 10.6531C12.2574 9.96586 12.5454 9.15815 12.6036 8.31828C12.6618 7.47841 12.488 6.6387 12.1012 5.89093C11.7144 5.14315 11.1295 4.51609 10.4104 4.07828C9.69133 3.64047 8.86573 3.40875 8.02385 3.40846C7.40251 3.40609 6.78728 3.53095 6.21603 3.77537C5.64479 4.01978 5.12963 4.37856 4.70231 4.82962L4.68077 4.85346L4.515 5.04577L3.38461 3.91577V7.33731Z",
    iconSoftReset: "M2.6702 2.1464L0.523804 0V6H6.5238L4.0918 3.568C5.11327 2.76215 6.403 2.28125 7.80505 2.28125C11.1188 2.28125 13.8051 4.96754 13.8051 8.28125C13.8051 11.595 11.1188 14.2812 7.80505 14.2812C4.97435 14.2812 2.6015 12.321 1.9699 9.68391L0 10.0445C0.803019 13.6144 3.9926 16.2812 7.80505 16.2812C12.2233 16.2812 15.8051 12.6995 15.8051 8.28125C15.8051 3.86297 12.2233 0.28125 7.80505 0.28125C5.85051 0.28125 4.05967 0.982185 2.6702 2.1464Z",
    kAxisDragStroke : "#737373",
    kAxisDragFill : "#EEEEEE",
    kAxisDragStrokeWidth : 1.1, // #2889 bug fix for Chrome Version 141.0 on MacOS 14.6.1 which renders 1.0 stroke width as a broken/pixelated line, but 1.1+ as solid.

    // Dataset Description summary
    // dsDescription: 'This dataset has the title {datasetTitle}. It has {caseCount} data points (or cases) and {attributeCount} attributes. There are {categoricalCount} categorical attributes and {numericalCount} numerical attributes.',
    dsDescription: 'This dataset has the title {0}. It has {1} data points (or cases) and {2} attributes. There are {3} categorical attributes and {4} numerical attributes.',
    // dsDescriptionCategorical: 'The {categoricalCount} categorical attributes are: {categoricalAttributes}.',
    dsDescriptionCategorical: 'The {0} categorical attributes are: {1}.',
    // dsDescriptionNumerical: 'The {numericalCount} numerical attributes are: {numericalAttributes}.',
    dsDescriptionNumerical: 'The {0} numerical attributes are: {1}.',

    // Plot Summary
    mixupPlotSummary: 'The cases in the plotting area are not organized and there are no attributes on the x-axis or y-axis.',
    plotTypeSummary: 'The plotting area has {0} cases organized in a {1}.',
    mapPlotSummary: 'The longitude and latitude coordinates are on the x- and y-axis, respectively. The plotting area has {0} cases overlaid on a map.',
    statsPlotSummary: 'The plot also displays the following statistics.',
    averagePlotSummary: 'The {0} of {1} is {2}.',
    averageCategoriesPlotSummary: 'The {0} of {1} is {2} where {3} is {4}.',
    leastSquaresPlotSummary: '{0} has the equation y = ({1}) x {2} {3} with r = {4}, r^2 = {5}{6} and {7}.',
    leastSquaresVarsPlotSummary: 'Y is {0}, X is {1}',
    leastSquaresByCategoryPlotSummary: 'Y is {0}, X is {1}, Category is {2}',
    movableLinePlotSummary: 'The movable line {0} has the equation {1}{2}.',
    sumOfSquaresPlotSummary: ', sum of squares = {0}', // inserted into movableLinePlotSummary as {2}, leastSquaresPlotSummary as {6}

    // axis
    attributeOnAxisSummary: 'The {0} has the {1} attribute {2}.',
    noAttributeOnAxis: 'There are no attributes on the {0}.',
    multipleNumericAttributeSummary: 'The {0} has the numerical attributes {1}.',
    numericalAttributeSummary: 'The range of the {0} is from {1} to {2} with an interval size of {3}.',
    categoricalAttributeSummary: '{0} has {1} categories: {2}.',
    frequencyAxisSummary: 'The {0} has the frequency axis.',
    percentageAxisSummary: 'The {0} has the percent axis.',
    disabledAxisSummary: 'The {0} has the {1} attribute {2}, but it is disabled.',

    // legend
    noLegendSummary: 'There is no attribute in the legend.',
    legendSummary: 'The legend has the {0} attribute {1}.',
    categoricalLegendAttributeSummary: 'The cases are colored by one of {0} categories. The {1} categories are {2}.',
    numericalLegendAttributeSummary: 'The cases are colored in a gradient from {0} to {1}.',
    missingCaseLegendSummary: 'The {0} attribute is missing for some of the cases.',

    // missing cases
    missingCasesSummary: 'There are {0} cases in the dataset and there are {1} cases that are missing values.',

    // aria label for axis and legend buttons
    axisCloseButtonAriaLabel : 'Remove {0} from the {1}',
    legendCloseButtonAriaLabel : 'Remove {0} from the Legend',
    plotTitleCloseButtonAriaLabel : 'Remove the plot title',
    promptAxisCloseButtonAriaLabel : 'Hide {0} Drop Area',
    promptLegendCloseButtonAriaLabel : 'Hide Legend Drop Area',
    promptBubbleLegendCloseButtonAriaLabel : 'Hide Bubble Size Drop Area',
    removeOrderByButtonAriaLabel : 'Remove {0} from the order of cases',

    getAxisRangeIcon : function( wantHorizontal ) {
        "use strict";
        var scale = "S1.5,1.5";
        // scale (S), rotate to vertical (R), transform (T) to put into exact position desired.
        return Raphael.transformPath( this.iconRangeHorzontal, scale + (wantHorizontal ? "T-8,-1" : "R-90T-14,5") );
    },
    getAxisMinIcon : function( wantHorizontal ) {
        "use strict";
        var scale = "S1.5,1.5";
        // scale (S), rotate to vertical (R), transform (T) to put into exact position desired.
        return Raphael.transformPath( this.iconAxisLeft, scale + (wantHorizontal ? "T10,3" : "R-90T3,10") );
    },
    getAxisMaxIcon : function( wantHorizontal ) {
        "use strict";
        var scale = "S1.5,1.5";
        // scale (S), rotate to vertical (R), transform (T) to put into exact position desired.
        return Raphael.transformPath( this.iconAxisRight, scale + (wantHorizontal ? "T0,3" : "R-90T-6,10") );
    },
    getXIcon : function( size ) {
        "use strict";
        // center on 0,0 and scale to size (typically this.iconSize)
        var scale = 0.6/20 * size;
        return Raphael.transformPath( this.iconX, "T-17,-16s"+scale+","+scale );
    },
	getPlusIcon : function( size ) {
		"use strict";
        // center on 0,0 and scale to size (typically this.iconSize)
        var scale = 0.6/20 * size;
		return Raphael.transformPath( this.iconPlus, "T-16.5,-17s"+scale+","+scale );
	},
	getMinusIcon : function( size ) {
		"use strict";
        // center on 0,0 and scale to size (typically this.iconSize)
        var scale = 0.6/20 * size;
		return Raphael.transformPath( this.iconMinus, "T-16.5,-17s"+scale+","+scale );
    },
    // get3DotIcon : function( size ) {
    //     // center on 0,0 and scale to size (typically this.iconSize)
    //     // http://complexdan.com/svg-circleellipse-to-path-converter/
    //     // 3 circles from [-15 to 15][-4 to -4], size 34 x 8
    //     const icon3Dots = "M-4,-15a4,4 0 1,0 8,0a4,4 0 1,0 -8,0 M-4,0a4,4 0 1,0 8,0a4,4 0 1,0 -8,0 M-4,15a4,4 0 1,0 8,0a4,4 0 1,0 -8,0";
    //     var scale = 0.6/34 * size;
    //     return Raphael.transformPath( icon3Dots, "T0, 0s"+scale+","+scale );
    // },
    getContextMenuIcon : function( size ) {
        const iconMenu = "M21,0H3C1.343,0,0,1.343,0,3v18c0,1.656,1.343,3,3,3h18c1.656,0,3-1.344,3-3V3C24,1.343,22.656,0,21,0z   M10.667,19.334c0,0.176-0.07,0.346-0.195,0.471C10.347,19.93,10.177,20,10,20H4.667c-0.177,0-0.346-0.07-0.471-0.195  S4,19.51,4,19.334V14c0-0.178,0.07-0.347,0.195-0.472c0.125-0.126,0.294-0.195,0.471-0.195H10c0.177,0,0.346,0.069,0.471,0.195  c0.125,0.125,0.195,0.294,0.195,0.472V19.334z M10.667,9.999c0,0.177-0.07,0.347-0.195,0.472c-0.125,0.125-0.294,0.195-0.471,0.195  H4.667c-0.177,0-0.346-0.07-0.471-0.195S4,10.176,4,9.999V4.667C4,4.49,4.07,4.32,4.195,4.195S4.49,4,4.667,4H10  c0.177,0,0.346,0.07,0.471,0.195c0.125,0.125,0.195,0.294,0.195,0.471V9.999z M20,19.334c0,0.176-0.07,0.346-0.195,0.471  S19.51,20,19.334,20h-5.333c-0.177,0-0.347-0.07-0.472-0.195s-0.195-0.295-0.195-0.471V14c0-0.178,0.07-0.347,0.195-0.472  c0.125-0.126,0.295-0.195,0.472-0.195h5.333c0.176,0,0.346,0.069,0.471,0.195C19.93,13.653,20,13.822,20,14V19.334z M20,9.999  c0,0.177-0.07,0.347-0.195,0.472s-0.295,0.195-0.471,0.195h-5.333c-0.177,0-0.347-0.07-0.472-0.195s-0.195-0.295-0.195-0.472V4.667  c0-0.177,0.07-0.346,0.195-0.471S13.824,4,14.001,4h5.333c0.176,0,0.346,0.07,0.471,0.195S20,4.49,20,4.667V9.999z"
        var scale = 0.7/34 * size * 2;
        return Raphael.transformPath( iconMenu, "T"+-12.5+","+-12.5+"s"+scale+","+scale );
    },
    getSettingsIcon : function( size ) {
        var scale = 1/20 * size; // 1:1 scale is for 20 pixel button
        // center on 0,0
		return Raphael.transformPath( this.iconSettings, "T-8.5,-8.5"+"s"+scale+","+scale );
	},
	getMissingValueIcon : function() {
		"use strict";
		// center on 0,0 and scale to this.iconSize
		//var left = 21;
		return Raphael.transformPath( this.iconMissingValue, "T-17,-17s0.6,0.6" );
	},
	getFilterIcon : function( desiredHeight ) {
		"use strict";
		var x = 216, y = 172, w = 138, h = 168,
			newH = desiredHeight || this.iconSize,
			xOffset = -(x + (w * 0.5)),
			yOffset = -(y + (h * 0.5)),
			scale = newH/h;
		// center on 0,0 and scale to this.iconSize
		return Raphael.transformPath( this.iconFilter, "T"+xOffset+","+yOffset+"s"+scale+","+scale );
	},
	getSwapIcon : function( size ) {
		"use strict";
        var path = this.iconSwap1+this.iconSwap2,
            scale = 1/20 * size,
            xOffset = 3 * scale,
            yOffset = (3 * scale) - 8;
        // top,left is 0,0 and scale to size (typically this.iconSize)
        return Raphael.transformPath( path, "T"+xOffset+","+yOffset+"s"+scale+","+scale );
	},
	getFitEquationIcon : function() {
		"use strict";
		return this.iconFitIcon1+this.iconFitIcon2;
	},
	getPencilIcon : function(size) {
		"use strict";
        var scale = 0.06 * size;
		return Raphael.transformPath( this.iconPencil, "T-8,-9s"+scale+","+scale );
	},
    getSoftResetIcon : function(size) {
        const scale = 0.075 * size;
        return Raphael.transformPath( this.iconSoftReset, "T-8,-8.5" +
            "s"+scale+","+scale );
    },

	textBBoxBeforeTransform : true, // for textElement.getBBox( Dyn.plotUtil.textBBoxBeforeTransform )
	textBBoxAfterTransform : false, // for textElement.getBBox( Dyn.plotUtil.textBBoxAfterTransform )

	/**
	 * Get the text transformation need to position the text relative to any anchor point.
	 * Positions can be:
	 * 	 in x: left, center, right
	 * 	 in y: top, center, bottom
	 * 	 rotation: 'r90' for clockwise, 'r-90' for counter-clockwise.
	 * Note: we need this because .attr({ 'text-anchor': 'start', 'transform': 'r90' }) does not work as desired.
	 * 	     and 'text-anchor' does not provide vertical positioning, only horizontal.
	 * @param textElem {*} -- Rafael text element created with paper.text( x, y, string )
	 * @param position {String} -- Transformation required
	 * @returns {String} - transform string for textElement.attr('transform',string)
	 */
	getTextTransform : function( textElem, position ) {
		"use strict";
		var bbox = textElem.getBBox( Dyn.plotUtil.textBBoxBeforeTransform ),
			w2 = bbox.width / 2,
			h2 = bbox.height / 2,
			t;

		switch( position ) {
		case "right,top":
			t="t-"+w2+","+h2; // anchor to x:right, y:top of text
			break;
		case "center,top":
			t="t0,"+h2; // anchor to x:center, y:top of text
			break;
		case "left,top":
			t="t"+w2+","+h2; // anchor to x:left, y:top of text
			break;
        case "right,bottom":
            t="t"+(-w2)+","+(-h2); // anchor to x:right, y:top of text
            break;
        case "center,bottom":
            t="t0,"+(-h2); // anchor to x:center, y:top of text
            break;
        case "left,bottom":
            t="t"+w2+","+(-h2); // anchor to x:left, y:top of text
            break;
		case "right,center":
			t="t-"+w2+",0"; // anchor to x:right edge, y-center of text
			break;
        case "left,center":
            t="t"+w2+",0"; // anchor to x:left edge, y-center of text
            break;
        case "center,center":
            t="t0,0"; // x:center, y:center; this is the default for Rafael text
            break;
        case "r90,center,center":
            t="r90t0,0"; // x:center, y:center; this is the default for Rafael text
            break;
		case "r90,center,top":
			t="r90t"+w2+",0" ; // rotate 90 degrees clockwise, anchor to center-top of rotated text
			break;
		case "r90,right,center":
			t="r90T-"+h2+",0"; // rotate 90 degrees clockwise, anchor to right-center edge of rotated text
			break;
        case "r-90,left,center":
            t="r-90T"+h2+",0"; // rotate 90 degrees counter-clockwise, anchor to left-center edge of rotated text
            break;
        case "r-90,right,center":
            t="t-"+h2+",0r-90"; // rotate 90 degrees CCW, anchor to right-center edge of rotated text
            break;
        case "r-90,center,top":
            t="t0,"+w2+"r-90"; // rotate 90 degrees CCW, anchor to center-top of text
            break;
		// add other cases as needed
		default:
			Dyn.assert( false, "unknown text position");
			t="t0,0";
		}
		return t;
	},

    /**
     * Get the bounding box of the given text string (by creating the element then removing it).
     * @param paper -- the Raphael panel to display on
     * @param string
     * @param fontSize
     * @param {boolean} [rotateToVertical=false]
     * @returns {*}
     */
    getTextBBox: function( paper, string, fontSize, rotateToVertical ) {
        "use strict";
        var textElem = paper.text( -900, -900, string ).attr( "font-size", fontSize ),
            textBBox;
        if( rotateToVertical ) {
            textElem.attr( "transform", "r90" );
        }
        textBBox = textElem.getBBox();
        textElem.remove();
        return textBBox;
    },

    /**
     * Get the bounding box of the given SVG path string (by creating the element then removing it).
     * @param paper -- the Raphael panel to display on
     * @param pathString -- Raphael/SVG path string
     * @returns {*}
     */
    getPathBBox: function( paper, pathString ) {
        let path = paper.path( pathString  ),
            pathBBox = path.getBBox( true ); // untransformed bbox
        path.remove();
        return pathBBox;
    },

    addTextElementDebugRect( paper, textElement, optionalStroke, optionalFill ) {
        if( Dyn.debugViewRects ) {
            Dyn.plotUtil.addDebugRect( paper, textElement, textElement.getBBox(), optionalStroke, optionalFill );
        } else {
            Dyn.plotUtil.removeDebugRect( textElement );
        }
    },

    /**
     * add a visible rectangle for debugging, using a Rafael.paper() and optional color values.
     * @param paper -- raphael paper
     * @param parentObject -- object to attach visible rectangle to
     * @param bbox {x,y,height,width} -- retangle location in paper (e.g. bbox of object)
     * @param optionalStroke -- optional outline color
     * @param optionalFill -- optional fill color
     */
    addDebugRect: function( paper, parentObject, bbox, optionalStroke, optionalFill ) {
        if( ! Dyn.debugViewRects) {
            // remove it if not debugging
            this.removeDebugRect( parentObject );
        } else {
            let strokeColor = optionalStroke || "#dd3",
                fillColor = optionalFill || "none",
                corner = Math.min( 10, 0.5 * Math.min( bbox.width, bbox.height ));
            Dyn.assertValidRect( bbox, "addDebugRect() invalid rectangle dimensions");
            if( ! parentObject.debugRect ) {
                // create it if it does not exist
                parentObject.debugRect = paper.rect(
                    bbox.x, bbox.y, bbox.width, bbox.height, corner ).
                attr( {stroke: strokeColor, fill: fillColor });
                //console.log( "addDebugRect() create" );
            } else {
                // update it to current position and color
                parentObject.debugRect.attr( {
                    x: bbox.x, y: bbox.y, width: bbox.width, height: bbox.height, r: corner,
                    stroke: strokeColor, fill: fillColor });
                //console.log( "addDebugRect() update" );
            }
        }
    },

    /** remove the view rectangle used for debugging. See addDebugRect() */
    removeDebugRect : function( parentObject ) {
        if( parentObject.debugRect ) {
            parentObject.debugRect.remove();
            delete parentObject.debugRect;
            //console.log( "removeDebugRect()" );
        }
    },

	/**
	 * unescape to show the correct symbols for greaterThan, lessThan
	 * & and quotes properly when displaying on the axis title
	 * or tick label. To start with we are escaping those values
	 * to avoid XSS on content in the uploaded data.
	 * e.g. one can upload <a onclick=alert("hi")>Hello<a>
	 * or similar more sophisticated sniffing code in data.
	 */
	unescapeText: function( safeText ) {
		"use strict";
		if (typeof safeText === "string") {
			return safeText.replace(/&amp;/g, "&")
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">")
				.replace(/&quot;/g, '"')
				.replace(/&#039;/g, "'");
		} else {
			return safeText;
		}
	},

	/**
	 * Check if the property exists in the dictionary key hierarchy
	 */
	checkNestedProp: function(obj, level,  ...rest) {
		if (obj === undefined)
			return false;
		if (rest.length == 0 && obj.hasOwnProperty(level))
			return true;
  		return Dyn.plotUtil.checkNestedProp(obj[level], ...rest);
	},

    /**
     * [slugify description]
     * @param  {[type]} text [attribute name]
     * @return {[type]}      [slug value of the given attribute name]
     */
    slugify: function( text ) {
        "use strict";
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    },

	/**
	 * Disable mouse-over events ("pointer-events"), so this element does not interfere
	 * with an overlapping element that *does* want to handle the mouseover event.
	 */
	disableMouseOverEvents : function( raphaelElement ) {
		raphaelElement.node.setAttribute("pointer-events", "none");
	},
    disableKeyboardFocus : function( raphaelElement ) {
        raphaelElement.node.setAttribute("focusable", false);
    },

	/**
	 * (Re-)enable mouse-over events ("pointer-events"), to undo disableMouseOverEvents().
	 */
	enableMouseOverEvents : function( raphaelElement ) {
		raphaelElement.node.setAttribute("pointer-events", "auto");
	},
    enableKeyboardFocus : function( raphaelElement ) {
        raphaelElement.node.setAttribute("focusable", true);
    },

    /**
     * Workaround for bugs found in Chrome for Mac iPad simulator 2018-08-30 (cdm)
     */
    safeStopPropogation : function( event ) {
        if( event ) {
            if( event.stopImmediatePropagation ) {
                event.stopImmediatePropagation(); // works on most devices
            } else {
                event.stopPropagation(); // for iPad which doesn't have stopImmediatePropogation() for touchstart event
            }
        }
    },

	/**
	 * return True if element exists and visible.
	 */
	isElementVisible : function( raphaelElement ) {
		if(raphaelElement?.type === "set") {
            raphaelElement = raphaelElement[0]; // check first element
        }
		return raphaelElement && raphaelElement.node?.style?.display !== "none";
	},

    /**
     * Show or hide the given element, do nothing if null.
     * @param raphaelElement { {*} | null }
     */
    showOrHideElement : function( raphaelElement, isShow ) {
        if( raphaelElement ) {
            if( isShow ) {
                raphaelElement.show();
            } else {
                // Clean up focus outline before hiding (Safari only)
                if( Dyn.plotUtil.isSafari() && raphaelElement.cleanupFocusOutline ) {
                    raphaelElement.cleanupFocusOutline();
                }
                raphaelElement.hide();
            }
        }
    },

    /**
     * Convert the Raphael element.hover() callback parameters to the same coordinates as the Raphael paper.
     * @param event
     * @param element
     * @returns {{x: number, y: number}}
     */
    hoverEventToPaperXY : function( event, element ) {
	    var x = /*event.layerX ||*/ event.offsetX || 0, // #2362 - layerX/Y no longer accurate in Firefox
            y = /*event.layerY ||*/ event.offsetY || 0;
	    return { x:x, y:y };
    },

	/**
	 * Convert the Raphael element.drag() callback parameters to the same coordinates as the Raphael paper.
	 * For callbacks to dragMove( dx, dy, x, y, event ), where x and y are the same x and y as the dragStart.
	 * Example:
	 * 	dragMove( dx, dy, x, y, event, element ) {
	 * 		var start = Dyn.plotUtil.dragEventXYtoPaperXY( x, y, event, element.paper ),
	 * 			startX = start.x,
	 * 			startY = start.y,
	 * 			currentX = startX + dx,
	 * 			currentY = startY + dy;
	 * }
	 * @param dragX
	 * @param dragY
	 * @param dragEvent
     * @param paper
	 * @returns {{x: (number|*), y: (number|*)}}
	 */
	dragEventXYtoPaperXY : function( dragX, dragY, dragEvent, paper ) {
		"use strict";
		// Use paper.canvas.getBoundingClientRect() as stable object to convert x, y from page to plotView.paper coordinates
        //  NOTE: previously we used dragEvent.target.getBoundingClientRect() or paper.node.bottom which were not stable objects.
		var rect = paper.canvas.getBoundingClientRect(),
			x = dragX - rect.left,
			y = dragY - rect.top;

		// Datasets page seems to need the extra offset "event.pageY - event.clientY" which is 0 in other views.
		if( Number.isFinite( dragEvent.pageX ) && Number.isFinite( dragEvent.clientX )) {
            x -= (dragEvent.pageX - dragEvent.clientX);
            y -= (dragEvent.pageY - dragEvent.clientY);
        } else {
            // don't use pageX - clientX offset if not defined.
            // NOTE: iPad/iPhone simulation in chrome on MacOS does not define .pageX --2017-10-09 CDM
            // NOTE: iPhone + iOS 11.1.2 does not define .clientX, tested using Safari developer mode --2017-12-11 CDM
		    //console.log("dragEventXYtoPaperXY missing pageX or clientX");
        }
		return { x:x, y:y };
	},

    /**
     * Get the x, y position of the mouse in click coordinates
     * @param event - click() event object
     * @param element - Raphael element that is getting the click() callback
     */
    getClickEventPaperXY : function( event, element ) {
        "use strict";
	    // based on:
        //  http://stackoverflow.com/questions/15257059/how-do-i-get-an-event-in-raphaels-paper-coordinates
        //
        // get bounding rect of the paper
        var bnds = event.target.getBoundingClientRect();
        var targetBox = element.getBBox();

        // adjust mouse x/y
        var mx = event.clientX - bnds.left;
        var my = event.clientY - bnds.top;

        // divide x/y by the bounding w/h to get location %s and apply factor by actual paper w/h
        var fx = mx/bnds.width * element.attrs.width + targetBox.x;
        var fy = my/bnds.height * element.attrs.height + targetBox.y;

        // cleanup output
        fx = Number(fx).toPrecision(3);
        fy = Number(fy).toPrecision(3);
        return { x:fx, y:fy };
    },

    /**
     * Get the x, y position of the mouse click or keypress target center point
     * @param event - click() event object
     * @param element - Raphael element that is getting the click() callback
     */
    clickOrKeyboardEventToViewportXY : function( event, element ) {
        var rect = event.target.getBoundingClientRect(),
            x = isFinite( event.clientX ) ? event.clientX : (rect.x + rect.width / 2),
            y = isFinite( event.clientY ) ? event.clientY : (rect.y + rect.height / 2);
        // console.log( "clickOrKeyboardEventToViewportXY() event:", "x:", x, "y:", y, event,
        //     element?.paper.canvas.getBoundingClientRect(),
        //     element?.node.getBoundingClientRect() );
        return { x:x, y:y };
    },

	/**
	 * Shorten the text string to fit within the given view width,
	 * by removing characters at the end, and adding "..." or the optional
	 * ellipsis string (e.g. '').
	 * @param textElem {paper.text}
	 * @param widthOfView
	 * @param [optionalEllipsisString]
	 * @returns {Object} -- returns final string bbox with {width,height}
	 */
	clipStringToWidth : function ( textElem, widthOfView, optionalEllipsisString ) {
		"use strict";
		//Dyn.time("clipStringToWidth","Start");

        function update( textElem, newString ) {
            textElem.attr( "text", newString );
            return textElem.getBBox( Dyn.plotUtil.textBBoxBeforeTransform );
        }

		// check fit of full string
        let bbox = textElem.getBBox( Dyn.plotUtil.textBBoxBeforeTransform );
		if( bbox.width > widthOfView ) {
		    // we need to shorten the string
            let newString = optionalEllipsisString || "...",
                oldString = textElem.attr("text" );

            // swap in new string starting with "..."
            bbox = update( textElem, newString );

            // add each oldString character to newString, and stop when width exceeded
            for( let i = 0, j = oldString.length; i < j; i++ ) {
                if( bbox.width < widthOfView ) {
                    // add i-th old character to new string (e.g. "..." to "t...")
                    newString = newString.substring(0, i) + oldString.substring(i,i+1) + newString.substring(i);
                    bbox = update( textElem, newString );
                } else {
                    // remove the i-1 old character, it does not fit (e.g. "text..." to "tex...")
                    if( i > 0 ) {
                        newString = newString.substring( 0, i - 1 ) + newString.substring( i );
                        bbox = update( textElem, newString );
                    }
                    break; // exit loop
                }
            }
        }
        //Dyn.time("clipStringToWidth","End");
		return bbox;
	},

    /**
     * wrap the text element text to the given view width, making multi-line text if needed,
     * so it is as wide as possible but no wider than the view.  Newline characters '\n'
     * are added and removed as needed.
     * @param textElem -- Raphael element with text (may have line breaks already)
     * @param widthOfView -- view width to stay inside of
     * @param alwaysReWrap -- if true always re-wrap; otherwise keep existing wrapping if narrow enough
     * @returns {*}
     */
    wrapStringToWidth : function ( textElem, widthOfView, alwaysReWrap ) {
        function update( textElem, newString ) {
            textElem.attr( "text", newString );
            return textElem.getBBox( Dyn.plotUtil.textBBoxBeforeTransform );
        }

        // check fit of full string
        let bbox = textElem.getBBox( Dyn.plotUtil.textBBoxBeforeTransform );
        if( alwaysReWrap || bbox.width > widthOfView ) {
            // we need to wrap the string
            let newString = "",
                words = textElem.attr("text").replaceAll('\n',' ').split(' ');
            words.forEach( (word, index) => {
                let testString = newString + ((index===0)?'':' ') + word;
                bbox = update( textElem, testString );
                if( bbox.width < widthOfView || index===0 ) {
                    // accept new word on existing line
                    newString = testString;
                } else {
                    // put new word on a new line
                    newString = newString+'\n'+word;
                    bbox = update( textElem, newString );
                }
            });
        }
        return bbox;
    },

	/**
	 * Return the two points in logical coordinates where the line with the given
	 * slope and intercept intersects the rectangle defined by the upper and lower
	 * bounds of the two axes.
	 * The returned object has the form
	 *    { pt1: { x, y }, pt2: { x, y }}
	 */
	lineToAxisIntercepts: function( slope, intercept, xAxis, yAxis) {
		"use strict";

		function getLogicalBoundsRect() {
		  return {
		    left: xAxis.numeric.axisRange.min,
		    top: yAxis.numeric.axisRange.max,
		    right: xAxis.numeric.axisRange.max,
		    bottom: yAxis.numeric.axisRange.min
		  };
		}

		var tX1, tY1, tX2, tY2,
		  tLogicalBounds = getLogicalBoundsRect();
		// Things can get hairy for nearly horizontal or nearly vertical lines.
		// This conditional takes care of that.
		if (Math.abs( slope ) > 1) {
		  tY1 = tLogicalBounds.bottom;
		  tX1 = (tY1 - intercept) / slope;
		  if (tX1 < tLogicalBounds.left) {
		    tX1 = tLogicalBounds.left;
		    tY1 = slope * tX1 + intercept;
		  }
		  else if (tX1 > tLogicalBounds.right) {
		    tX1 = tLogicalBounds.right;
		    tY1 = slope * tX1 + intercept;
		  }

		  tY2 = tLogicalBounds.top;
		  tX2 = (tY2 - intercept) / slope;
		  if (tX2 > tLogicalBounds.right) {
		    tX2 = tLogicalBounds.right;
		    tY2 = slope * tX2 + intercept;
		  }
		  else if (tX2 < tLogicalBounds.left) {
		    tX2 = tLogicalBounds.left;
		    tY2 = slope * tX2 + intercept;
		  }
		}
		else {
		  tX1 = tLogicalBounds.left;
		  tY1 = slope * tX1 + intercept;
		  if (tY1 < tLogicalBounds.bottom) {
		    tY1 = tLogicalBounds.bottom;
		    tX1 = (tY1 - intercept) / slope;
		  }
		  else if (tY1 > tLogicalBounds.top) {
		    tY1 = tLogicalBounds.top;
		    tX1 = (tY1 - intercept) / slope;
		  }

		  tX2 = tLogicalBounds.right;
		  tY2 = slope * tX2 + intercept;
		  if (tY2 > tLogicalBounds.top) {
		    tY2 = tLogicalBounds.top;
		    tX2 = (tY2 - intercept) / slope;
		  }
		  else if (tY2 < tLogicalBounds.bottom) {
		    tY2 = tLogicalBounds.bottom;
		    tX2 = (tY2 - intercept) / slope;
		  }
		}

		// keep x1 < x2
		if (tX1 > tX2) {
		  var tmp = tX1;
		  tX1 = tX2;
		  tX2 = tmp;

		  tmp = tY1;
		  tY1 = tY2;
		  tY2 = tmp;
		}
		return {
		  pt1: { x: tX1, y: tY1 },
		  pt2: { x: tX2, y: tY2 }
		};
	},

    /**
     * Convert the lineToAxisIntercepts() points from attribute data coordinates to axis view coordinates.
     * Adds the results to the intercepts object */
    addAxisInterceptsViewPts: function( intercepts, xAxisView, yAxisView ) {
        intercepts.viewPt1 = {
            x:xAxisView.dataToPixel( intercepts.pt1.x ),
            y:yAxisView.dataToPixel( intercepts.pt1.y ) };
        intercepts.viewPt2 = {
            x:xAxisView.dataToPixel( intercepts.pt2.x ),
            y:yAxisView.dataToPixel( intercepts.pt2.y ) };
    },

	/**
	 * Find m, b and r^2 - Linear regression, line of best fit
	 * @param xAttribute {Dyn.Attribute | Dyn.CombinedAttributes}
	 * @param yAttribute {Dyn.Attribute | Dyn.CombinedAttributes}
	 * @param filterFunction {function} - function( filterParams, caseIndex, xValue, yValue ){}
     * @param filterParams {*} - object with any static parameters needed by filterFunction
	 * @returns {{slope: number, intercept: number, r2: number}}
	 */
	findLineByLeastSquares: function( xAttribute, yAttribute, filterFunction, filterParams ) {
		"use strict";
	    let sum_x = 0,
            sum_y = 0,
            sum_xy = 0,
            sum_xx = 0,
            sum_yy = 0,
            //sumSquares = 0,
            count = 0;
	    //use those variables for faster read/write access.
	    let x = 0,
            y = 0,
            casesLength = Math.min( xAttribute.cases.length, yAttribute.cases.length );

	    // calculate the sum for each of the parts necessary.
	    for (let ci = 0; ci < casesLength; ci++) {
			x = xAttribute.cases[ci];
			y = yAttribute.cases[ci];
	    	// skipping non-numeric and missing and filtered cases
            if( filterFunction( filterParams, ci, x, y )) {
		        sum_x += x;
		        sum_y += y;
		        sum_xx += x*x;
		        sum_xy += x*y;
		        sum_yy += y*y;
		        count++;
	    	}
	    }
	    /*
	     * find slope (m) and intercept (b) for the formula:
	     * y = x * m + b
	     */
        if( count < 2 ) {
            return { "slope": NaN, "intercept": NaN, "r2": NaN };
        }
	    let m = (count*sum_xy - sum_x*sum_y) / (count*sum_xx - sum_x*sum_x),
	        b = (sum_y/count) - (m*sum_x)/count,
            r = (count*sum_xy - sum_x*sum_y)/Math.sqrt((count*sum_xx-sum_x*sum_x)*(count*sum_yy-sum_y*sum_y)),
	        r2 = Math.pow(r,2);
        // #1664 fix precision
        m = Dyn.mathUtil.fixPrecision(m);
        b = Dyn.mathUtil.fixPrecision(b);
        r = Dyn.mathUtil.fixPrecision(r);
        r2 = Dyn.mathUtil.fixPrecision(r2);
	    return {
                "slope": m, "intercept": b,
                "r": r, "r2": r2,
                fx : function(x) { return m * x + b; } // line equation
            };
	},

    /** calculate the sum of squares (must be a 2nd pass) */
    calcSumOfSquares( xAttribute, yAttribute, filterFunction, filterParams, lineEquation ) {
        let sumOfSquares = 0,
            // m = leastSquares.slope,
            // b = leastSquares.intercept,
            casesLength = Math.min( xAttribute.cases.length, yAttribute.cases.length );

        for (let ci = 0; ci < casesLength; ci++) {
            let x = xAttribute.cases[ci],
                y = yAttribute.cases[ci];
            // skipping non-numeric and missing and filtered cases
            if( filterFunction( filterParams, ci, x, y )) {
                let y2 = lineEquation.fx( x );
                if( Number.isFinite( y2 ) ) { // skip NaN and infinite values
                    sumOfSquares += (y - y2) * (y - y2);
                }
            }
        }
        return sumOfSquares;
    },

    /*
     * find slope (m) and intercept (b) for the formula:
     * y = x * m + b
     */
	findLineByTwoPoints: function( x1, y1, x2, y2 ) {
		var m, b;
		if( ! Dyn.mathUtil.isClose( x1, x2 )) {
			m = (y1 - y2) / (x1 - x2);
			b = y1 - ( m * x1 );
		}
		return {
            slope: m,
            intercept: b,
            fx : function(x) { return m * x + b; } // line equation
        };
	},


		/** make an arc around circle centered on cx, cy, radius r, with fracion [0-1] of complete circle. */
	makeArcPath: function( cx, cy, r, fraction ) {
		"use strict";
		var a1 = Math.PI * 1.5,
			a2 = a1 + (fraction * Math.PI * 2),
			flag = (a2-a1) > Math.PI,
			path = (fraction > 0.99 ) ? Dyn.plotUtil.makeCirclePath( cx, cy, r ) :
				[
					["M", cx, cy],
					["m", r * Math.cos(a1), r * Math.sin(a1)],
					["A", r, r, 0, +flag, 1, cx + r * Math.cos(a2), cy + r * Math.sin(a2)]
					//["z"]
				];
		return path;
	},

	makeCirclePath : function( cx, cy, radius ) {
		"use strict";
		var x1 = ( cx ).toFixed(1),
			y1 = ( cy - radius ).toFixed(1),
			x2 = ( cx ).toFixed(1),
			y2 = ( cy + radius ).toFixed(1),
			rotation = " 0 0,1 ", // x-axis-rotation large-arch-flag,sweepflag, 1 means clockwise
			pathString =
				"M" + x1 + "," + y1 +	// move to top
				" A" + radius + "," + radius + rotation + x2 + "," + y2 +  // clockwise arc to x2, y2
				" A" + radius + "," + radius + rotation + x1 + "," + y1 +  // clockwise arc to x1, y1
				" z";					// line back to center
		return pathString;
	},

    makeRectanglePath : function( rect ) {
        "use strict";
        var x1 = ( rect.x ).toFixed(1),
            y1 = ( rect.y ).toFixed(1),
            x2 = ( rect.x + rect.width ).toFixed(1),
            y2 = ( rect.y + rect.height ).toFixed(1),
            pathString =
                "M" + x1 + "," + y1 +
                    "L"+ x1 +","+ y2+
                    "L"+ x2 +","+ y2+
                    "L"+ x2 +","+ y1+
                    "z"; // line back to start
        return pathString;
    },

    /**
     * Make a line path from start to end with an arrow at the end
     * @param startX
     * @param startY
     * @param endX
     * @param endY
     * @param arrowLength
     * @param arrowWidth
     * @param lineWidth
     * @returns {string}
     */
    makeArrowPath : function( startX, startY, endX, endY, arrowLength, arrowWidth, lineWidth  ) {
        const adjArrowWidth = arrowWidth*0.4 + lineWidth*3; // adjust arrow width to account for line width
        const aLine = Dyn.mathUtil.angle( endX - startX, endY - startY ), // angle of line from start to end
            aLeft = Dyn.mathUtil.angle( -arrowLength, adjArrowWidth/2 ), // angle of left arrow point from line
            aRight = Dyn.mathUtil.angle( -arrowLength, -adjArrowWidth/2 ); // angle of right arrow point from line
        const halfWidth = lineWidth / 2, // half the width of the line
            midLength = 0.8 * arrowLength, // length of line to mid-point of arrow
            xm1 = Dyn.mathUtil.polarToX( halfWidth, aLine-(Math.PI/2)),
            ym1 = Dyn.mathUtil.polarToY( halfWidth, aLine-(Math.PI/2)), // start point offset 90 degrees by half a line width
            xm2 = Dyn.mathUtil.polarToX( halfWidth, aLine+(Math.PI/2)),
            ym2 = Dyn.mathUtil.polarToY( halfWidth, aLine+(Math.PI/2)); // start point offset 90 degrees by half a line width
        const xMid = ( endX - Dyn.mathUtil.polarToX( midLength, aLine )),
            yMid = ( endY - Dyn.mathUtil.polarToY( midLength, aLine )),
            xLeft = ( endX + Dyn.mathUtil.polarToX( arrowLength, aLine + aLeft )),
            yLeft = ( endY + Dyn.mathUtil.polarToY( arrowLength, aLine + aLeft )),
            xRight = ( endX + Dyn.mathUtil.polarToX( arrowLength, aLine + aRight )),
            yRight = ( endY + Dyn.mathUtil.polarToY( arrowLength, aLine + aRight ));
        let pathString =
                "M" + (startX+xm1).toFixed(1) + "," + (startY+ym1).toFixed(1) + // line from start, with half-width offset
                "L"+ + (xMid+xm1).toFixed(1) + "," + (yMid+ym1).toFixed(1) + // to start of arrow, with half-width offset
                "L"+ (xRight+xm1).toFixed(1) +","+ (yRight+ym1).toFixed(1) + // to left (counter-clockwise arrow point)
                "L"+ ( endX ).toFixed(1) +","+ ( endY ).toFixed(1) + // to end
                "L"+ (xLeft+xm2).toFixed(1) +","+ (yLeft+ym2).toFixed(1) + // to right (clockwise arrow point)
                "L"+ (xMid+xm2).toFixed(1) + "," + (yMid+ym2).toFixed(1) + // to end
                "L"+ (startX+xm2).toFixed(1) + "," + (startY+ym2).toFixed(1) + // to end
                "z"; // line back to start
        return pathString;
    },

    /**
     * Make a line path from start to end
     * @param startX
     * @param startY
     * @param endX
     * @param endY
     * @returns {string}
     */
    makeStraightLinePath : function( startX, startY, endX, endY ) {
        "use strict";
        var x1 = ( startX ).toFixed(1),
            y1 = ( startY ).toFixed(1),
            x2 = ( endX ).toFixed(1),
            y2 = ( endY ).toFixed(1),
            pathString =
                "M" + x1 + "," + y1 + // line from start
                "L"+ x2 +","+ y2; // to end
                // "L"+ x2 +","+ y2+ // to end
                // "z"; // line back to start
        return pathString;
    },

    /** make a polyline path, by connecting the points with line segments */
    makePolyLinePath: function( points /*, showPoints */ ) {
        let pathString = "";
        points.forEach( ( p, index ) => {
            pathString += (index === 0 ? "M" : " L") + p.x.toFixed( 0 ) + "," + p.y.toFixed( 0 );
        } );
        return pathString;
    },


    equalPoints: function( a, b ) {
        return a.x === b.x && a.y === b.y;
    },

    areaOfTriangle: function( a, b, c) {
        // compute the area of a triangle defined by three points
        // see https://en.wikipedia.org/wiki/Area_of_a_triangle, via the shoelace formula/surveyor's formula:
        return 0.5 * Math.abs((a.x - c.x)*(b.y - a.y) - (a.x - b.x)*(c.y - a.y));
    },

    /**
     * make a smoothed polyline from the points,
     * by creating a cubic bezier with control points every so often,
     * as determined by minDistSquared.
     * NOTE: if the first and last point have identical coordinates, the polyline
     * is closed.
     * @param points {array} - array of points {x,y} in the polyline
     * @param minDistSquared {number} - target minimum distance between control points
     * @param controlPointsOut {array} - set to array of control points used
     * @returns {string} - path string
     */
    makeSmoothPolyLinePath: function( points, minDistSquared, controlPointsOut ) {
        Dyn.assert( Number.isFinite( minDistSquared) && minDistSquared >= 0 );
        let cp=controlPointsOut || []; // control points; save with cpArray if given;

        getEvenlySpacedControlPoints( points, cp );
        let isClosedLoop = this.equalPoints( cp[0], cp[cp.length-1] )
        smoothControlPointsForCubicBezier( cp, isClosedLoop );
        let str = makeCubicBezierPath( cp, isClosedLoop );
        // console.log( "makeSmoothPolyLinePath", controlPointsOut?.length, str, isClosedLoop ? "closed":"open" );
        return str;

        function atLeastMinDist( a, b, minDistSquared ) {
            let x = a.x - b.x,
                y = a.y - b.y;
            return (x * x + y * y) >= minDistSquared;
        }
        function dist( a, b ) {
            let x = a.x - b.x,
                y = a.y - b.y;
            return Math.sqrt( x*x + y*y );
        }
        function midpoint( a, b ) {
            return { x:(a.x+b.x)/2, y:(a.y+b.y)/2 };
        }
        function reflect( a, b ) { // reflection of point 'a' through point 'b'
            return { x: b.x - (a.x - b.x), y: b.y - (a.y - b.y) };
        }
        function getEvenlySpacedControlPoints( points, cp ) {
            cp.length = 0;
            if( points.length >= 3) {
                let i, j, p, q;
                // get control points up to mid-point, spaced evenly from first point
                for( i = 0, j = points.length / 2; i < j; ++i ) {
                    p = points[i], q = (i > 0) && cp[cp.length - 1];
                    if( i === 0 || atLeastMinDist( p, q, minDistSquared ) ) {
                        cp.push( p );
                        // console.log( "add control point", i, q && "dist=" + dist( p, q ) );
                    }
                }
                // get control points from last down to mid-point, spaced evenly from last point
                const cpiMid = cp.length;
                for( i = points.length - 1, j = points.length / 2; i > j; --i ) {
                    p = points[i], q = (i < (points.length - 1)) && cp[cpiMid];
                    if( i === (points.length - 1) || atLeastMinDist( p, q, minDistSquared ) ) {
                        cp.splice( cpiMid, 0, p );
                        // console.log( "add control point", i, "at " + cpiMid, q && "dist=" + dist( p, q ), "length:" + cp.length );
                    }
                }
                // check control point length; add extra points if needed
                if( ((cp.length - 1) % 3) === 1 && (points.length > 1) ) {
                    // cp now has 1 extra point after making Cubic Bezier curves (e.g. 0, 1-2-3, 4-5-6, 7)
                    // now add another point, so we have 2 extra points,
                    // because we can make a quadratic Bezier with those last 2 points.
                    let p = midpoint( points[points.length - 1], points[points.length - 2] )
                    cp.splice( cp.length - 1, 0, p );
                    // console.log( "control point", p, cp.length, "added penultimate point to avoid 1 extra control point" );
                }
            }
        }
        function smoothControlPointsForCubicBezier( cp, isClosedLoop ) {
            // adjust points for cubic bezier handles, in groups of 3.
            // 0th and last and every 3rd point remains on polyline.
            const unchangedPoints = Array.from( cp );

            cp.forEach((p, i, array) => {
                let j = i - array.length; // index backwards (last==-1, 2nd last==-2, etc)
                if( (i%3)===1 && (isClosedLoop ? (j < -1 ) : ((i >= 2) && (j < -1)))) {
                    // if control point 1 of 3, and not at start/end
                    let r = pointAtIndex( i-1 ),
                        q = pointAtIndex( i-2 );
                    array[i] = midpoint( p, reflect( q, r )); // average with control point 2 of 3 in previous cubic bezier
                    // console.log( "midpoint of reflection", i, "(i%3)="+(i%3), "of "+array.length, p, r, q, "=>", reflect( q, r ), array[i]  );
                }
                if( (i%3)===2 && (isClosedLoop ? (j < -1) : (j < -2))) {
                    // if control point 2 of 3, and not at start/end
                    let r = pointAtIndex( i+1 ),
                        q = pointAtIndex( i+2 );
                    array[i] = midpoint( p, reflect( q, r )); // average with control point 1 of 3 in next cubic bezier
                    // console.log( "midpoint of reflection", i, "(i%3)="+(i%3), "of "+array.length, p, r, q, "=>", reflect( q, r ), array[i]  );
                }
            });
            return isClosedLoop;
            function pointAtIndex( n ) {
                let l = unchangedPoints.length,
                    m = n;
                if( isClosedLoop ) {
                    l -= 1; // length is one less, because last point===first point, treat them as one point
                    m = (l+n)%l; // wrap around the index to make a loop
                }
                let lp = unchangedPoints[m];
                Dyn.assert( lp, "pointAtIndex error for :"+m+" of "+unchangedPoints.length);
                return lp;
            }
        }
        function makeCubicBezierPath( cp, isClosedLoop ) {
            Dyn.assert( cp.length >= 1, "expecting 1+ control points");
            let pathString = "",
                iLastSegment;
            cp.forEach( ( p, i ) => { // for each control point of curve, if any
                const isLast = (i === cp.length - 1),
                    isFirst = (i === 0),
                    isSegmentEnd = ( i % 3 === 0 ),
                    pNeg1 = cp[i-1],
                    pNeg2 = cp[i-2];
                if( isFirst ) {
                    addToPath( i, "M" + coord(p)); // move to start
                } else if( isLast && (i - iLastSegment === 1) ) {
                    addToPath( i, " L" + coord( p )); // add last point as line segment
                } else if( isLast && (i - iLastSegment === 2) ) {
                    addToPath( i, " Q" + coord( pNeg1 ) + ',' + coord( p )) // add last 2 points as quadratic curve
                } else if( isSegmentEnd ) {
                    addToPath( i, " C" + coord( pNeg2 ) + ',' + coord( pNeg1 ) + ',' + coord( p )); // add cubic curve
                }
            } );
            if( cp.length <= 1 ) {
                pathString = ''; // give up, just draw a polyline
            } else if( isClosedLoop ) {
                pathString += 'z';
            }

            return pathString;

            function coord(p) {
                return '' + p.x.toFixed( 0 ) + ' ' + p.y.toFixed( 0 )
            }
            function addToPath( i, s ) {
                iLastSegment = i;
                pathString += s;
            }
        }
    },

    roundRectAxisButtonOptions : function() {
        // consolidate options for an axis button with a translucent, rounded background rect
        return { radius: Dyn.plotUtil.contextMenuRadius, opacity:Dyn.plotUtil.axisButtonOpacity };
    },

    /**
     * Make a square button with the given symbol path and invisible cover rectangle around it.
     * Returns a Raphael set with 2 elements.
     * Note:
     *  - callbacks for hover and click are over cover rect, but this===set.getSymbolElement()
     *  - caller should use set.data(), .show(), .hide(), to apply to all elements of set
     *  - caller should use set.transform() to position button
     * @param paper -- Raphael paper
     * @param symbolOrPath -- path string or path array or pre-build raphael element (e.g. paper.circle())
     * @param hoverInHandler
     * @param hoverOutHandler
     * @param clickHandler
     * @param keyHandlers
     * @param ariaLabel
     * @param elementId
     * @param [opts] {*} -- additional options like .radius
     * @returns {*} -- paper.set() with callbacks getCoverElement(), getSymbolElement()
     */
    makeSquareButton : function( paper, symbolOrPath, hoverInHandler, hoverOutHandler, clickHandler,
                                 keyHandlers, ariaLabel, elementId, opts ) {
        var opts = opts || {},
            symbolSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
            overSize   = 1, // extra space around icon
            coverPos   = -( symbolSize / 2 + overSize ),
            coverSize  = ( symbolSize + overSize ),
            viewOnly = Dyn.preferences.isViewOnly();

        // cover rectangle for larger click+hover area
        // normally invisible, but can be changed to an opaque or outlined background rect behind symbol
        // which is why the "cover" is actually underneath symbol in z-order
        let cover = paper.rect( coverPos, coverPos, coverSize, coverSize, opts.radius )
            .attr( Dyn.debugViewRects ?
                { fill: "orange", stroke: "none", opacity: 0.5 } : // make visible for debugging
                { fill: Dyn.plotUtil.axisButtonBgUpColor,  stroke: "none",
                    opacity: opts.opacity || Dyn.plotUtil.opacityInvisibleButDraggable } );
        cover.node.setAttribute("id", elementId);
        cover.node.setAttribute("role", "button");
        cover.node.setAttribute("class", Dyn.plotUtil.hideOnPreviewClass);

        // visible symbol
        let isPath    = ( typeof symbolOrPath === "string" || Array.isArray( symbolOrPath ) ),
            isElement = ( symbolOrPath.paper ),
            symbol    = ( isPath ? paper.path( symbolOrPath ) : symbolOrPath );
        Dyn.assert( isPath || isElement, "need path string or Raphael Element" );
        if( isPath ) {
            symbol.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } ); // fill the path
        } else {
            symbol.attr( { stroke: Dyn.plotUtil.axisButtonUpColor, fill: "none" } ); // e.g. outline of circle
        }
        Dyn.plotUtil.disableMouseOverEvents( symbol ); // so it does not interfere with outline's buttonHoverIn()
        symbol.node.setAttribute("class", Dyn.plotUtil.hideOnPreviewClass)

        // keyboard accessibility for axis and annotation buttons
        if( ! viewOnly ) {
            keyHandlers = keyHandlers || { deleteHandler:clickHandler };
            let keyDownHandler = function( e ) {
                //console.log( "makeSquareButton keydown:", e.key );
                switch( e.key) { // const {key} = event; ES6+
                case "Delete":
                case "Backspace":
                    if( keyHandlers.deleteHandler ) {
                        keyHandlers.deleteHandler.call( symbol, e );
                    }
                    break;
                case "Enter":
                    if( clickHandler ) {
                        clickHandler.call( symbol, e );
                    }
                    break;
                case "ArrowLeft":
                case "ArrowRight":
                case "ArrowUp":
                case "ArrowDown":
                    if( keyHandlers.arrowKeyHandler ) {
                        let dist = Dyn.plotUtil.arrowKeyAcceleratedDistance( e.key );
                        keyHandlers.arrowKeyHandler.call( symbol, dist.dx, dist.dy, e );
                        // Refresh focus outline after arrow key movement (Safari only)
                        if (Dyn.plotUtil.isSafari() && cover.refreshFocusOutline) {
                            // Small delay to ensure element repositioning is complete
                            setTimeout(() => cover.refreshFocusOutline(), 10);
                        }
                    }
                    break;
                }
            };
            // Blur handler moved to Safari methods section below
            Dyn.plotUtil.setKeyboardFocusable(cover, keyDownHandler, !!ariaLabel ? ariaLabel : false);
        }

        // set to contain them both
        let set = paper.set();
        set.push( cover, symbol ); // push in same order we create, for proper layering
        set.getCoverElement = function() { return this[0]; };
        set.getSymbolElement = function() { return this[1]; };
        symbol.getCoverElement = function() { return cover; }

        // Add methods for focus outline management (Safari only)
        if (Dyn.plotUtil.isSafari()) {
            set.createOrUpdateFocusOutline = function() {
                // Remove existing outline
                let focusOutline = cover.data('focusOutline');
                if (focusOutline) {
                    focusOutline.remove();
                }

                // Get current bounding box and create fresh outline
                let bbox = cover.getBBox();
                let outlineOffset = 2;

                focusOutline = paper.rect(
                    bbox.x - outlineOffset,
                    bbox.y - outlineOffset,
                    bbox.width + (outlineOffset * 2),
                    bbox.height + (outlineOffset * 2)
                ).attr({
                    stroke: '#1256C1',
                    'stroke-width': 2,
                    fill: 'none',
                    'stroke-dasharray': 'none'
                });

                focusOutline.toBack();
                symbol.toFront();
                cover.data('focusOutline', focusOutline);
            };

            set.cleanupFocusOutline = function() {
                let focusOutline = cover.data('focusOutline');
                if (focusOutline) {
                    focusOutline.remove();
                    cover.removeData('focusOutline');
                }
            };

            set.refreshFocusOutline = function() {
                // Only refresh if this element currently has focus
                if (document.activeElement === cover.node) {
                    set.createOrUpdateFocusOutline();
                }
            };

            cover.createOrUpdateFocusOutline = set.createOrUpdateFocusOutline;
            cover.cleanupFocusOutline = set.cleanupFocusOutline;
            symbol.cleanupFocusOutline = set.cleanupFocusOutline;
            cover.refreshFocusOutline = set.refreshFocusOutline;
            symbol.refreshFocusOutline = set.refreshFocusOutline;

            // Define the focus and blur handlers to use shared functions
            let focusHandler = function(e) {
                set.createOrUpdateFocusOutline();
            };

            let blurHandler = function(e) {
                // Remove the focus outline completely on blur
                let focusOutline = cover.data('focusOutline');
                if (focusOutline) {
                    focusOutline.remove();
                    cover.removeData('focusOutline');
                }
            };

            // Add focus/blur handlers for Safari SVG focus fix
            cover.node.addEventListener('focus', focusHandler);
            cover.node.addEventListener('blur', blurHandler);
        }

        // hover/click handlers for cover, with this===symbol
        if( clickHandler && ! viewOnly ) {
            cover.click( clickHandler.bind( symbol ) );
        }
        if( hoverInHandler && ! (Dyn.environment.isTouchDevice() || viewOnly)) { // #430 no hover for touch devices
            cover.hover( hoverInHandler.bind(symbol), hoverOutHandler.bind(symbol) )
        }
        if( viewOnly ) {
            set.hide();
        }
        return set;
    },

    /**
     * Make a close box with a visible "X"
     * and invisible cover rectangle for a larger click+hover area.
     * Returns a Raphael set with 2 elements.
     * Caller should position box with set.transform()
     * @param paper
     * @param hoverInHandler
     * @param hoverOutHandler
     * @param clickHandler
     * @param ariaLabel
     * @param elementId
     * @param [options] - options for makeSquareButtion(); null == use default
     * @returns {*} -- paper.set() with callbacks getCoverElement(), getSymbolElement()
     */
    makeCloseBox : function( paper, hoverInHandler, hoverOutHandler, clickHandler, ariaLabel, elementId, options) {
        options = options || Dyn.plotUtil.roundRectAxisButtonOptions();
        let symbolSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
            set = this.makeSquareButton(
                    paper,
                    Dyn.plotUtil.getXIcon( symbolSize ),
                    hoverInHandler,
                    hoverOutHandler,
                    clickHandler,
                    false, // no keyhandler
                    !!ariaLabel ? ariaLabel : Dyn.loc("Close"),
                    elementId,
                    options);
        set.data( 'type', "closebox" )
            .data( 'tooltip', ariaLabel || "" )
            .attr( 'cursor', Dyn.plotUtil.cursorPointer );
        return set;
    },

    /**
     * Make a context menu button, with the menu grid symbol
     * with an invisible cover rectangle for a larger click+hover area.
     * Returns a Raphael set with 2 elements.
     * Caller should position box with set.transform()
     * @param paper
     * @param clickHandler
     * @param keyHandlers
     * @param ariaLabel
     * @param elementId
     * @param [options] - options for makeSquareButtion(); null == use default
     * @returns @returns {*} -- paper.set() with callbacks getCoverElement(), getSymbolElement()
     */
    makeContextMenuButton : function( paper, clickHandler, keyHandlers, ariaLabel, elementId, options ) {
        function hoverInHandler( event ) {
            cover.attr({ fill: Dyn.plotUtil.axisButtonBgDownColor });
            this.attr( { fill: Dyn.plotUtil.contextMenuIconDownColor } );
            if( this.data("tooltip"))
                Dyn.toolTip.show( this, event, { x:this.getBBox().x2, y:this.getBBox().y2 });
        }
        function hoverOutHandler( event ) {
            cover.attr({ fill: Dyn.plotUtil.axisButtonBgUpColor });
            this.attr( { fill: Dyn.plotUtil.contextMenuIconUpColor } );
            if( Dyn.toolTip.isMyElement( this ))
                Dyn.toolTip.hide();
        }

        options = options || Dyn.plotUtil.roundRectAxisButtonOptions();
        var symbolSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.contextMenuSize ),
            set = this.makeSquareButton(
                    paper,
                    Dyn.plotUtil.getContextMenuIcon( symbolSize ),
                    hoverInHandler,
                    hoverOutHandler,
                    clickHandler,
                    keyHandlers,
                    !!ariaLabel ? ariaLabel : Dyn.loc("Menu"),
                    elementId,
                    options ),
            cover = set.getCoverElement();
        set.data( 'type', "contextMenu" )
            .data( 'tooltip', ariaLabel || "" )
            .attr( 'cursor', Dyn.plotUtil.cursorPointer );
        set.getSymbolElement().attr({ fill: Dyn.plotUtil.contextMenuIconUpColor });
        return set;
    },

    // remove each of an array of visible elements from Raphael paper (SVG)
	removeAndEmptyArrayOfElements : function( arrayOfRaphaelElements ) {
		"use strict";
		Dyn.assertValidArray( arrayOfRaphaelElements );
        arrayOfRaphaelElements.forEach( (el) => {
            Dyn.plotUtil.removeDebugRect( el );
            el.remove()
        });
		arrayOfRaphaelElements.length = 0; // empty the array
	},

    /** remove a Raphael element and its tooltip if it exists, including sets */
    removeElementAndToolTip( e ) {
        if( e.type==="set" ) {
            e.forEach( (e2) => Dyn.plotUtil.removeElementAndToolTip( e2 ));
            e.clear();
            e.remove();
        } else {
            if( Dyn.toolTip.isMyElement( e )) {
                Dyn.toolTip.hide();
            }
            e.remove();
        }
    },

    /** hide a Raphael element and its tooltip if it exists, including sets */
    hideElementAndToolTip( e ) {
        if( e.type==="set" ) {
            e.forEach( (e2) => Dyn.plotUtil.hideElementAndToolTip( e2 ));
        } else {
            if( Dyn.toolTip.isMyElement( e )) {
                Dyn.toolTip.hide();
            }
            e.hide();
        }
    },

	/**
     * Add to or remove from the number of intervals in the numeric interval range.
     * Used to handle the Plus and Minus button actions in a uniform way.
     * @param intervals {numIntervals) - intervals created by Dyn.dataUtil.calcNiceIntervals()
     * @param isPlus {boolean} - true if action is Plus (double) else Minus (half)
     */
    setNumIntervalsPlusMinus: function( intervals, isPlus ) {
        Dyn.assert( intervals.numIntervals && isFinite( intervals.numIntervals ));
        if( isPlus ) {
            intervals.numIntervals *= 2;
        } else {
            intervals.numIntervals = Math.floor( intervals.numIntervals / 2 );
        }
        intervals.numIntervals = Dyn.mathUtil.clipToMinMax(
            Dyn.plotUtil.kMinNumIntervals,
            Dyn.plotUtil.kMaxNumIntervals,
            intervals.numIntervals );
        // add flags for disabling +/- buttons
        intervals.setAtMinMax(
            intervals.numIntervals <= Dyn.plotUtil.kMinNumIntervals,
            intervals.numIntervals >= Dyn.plotUtil.kMaxNumIntervals );
    },

    /**
     * Trigger an event for a Raphaeljs object.
     * Example:
        var r = paper.rect(0,0,100,100).attr({"fill": "#f00"});
        r.click(function(){
            this.attr("fill": "#0f0");
        });
        triggerRaphaelEvent( r, "click" );
     * based on https://stackoverflow.com/questions/12059592/triggering-raphael-events-externally
     * @param rElement -- Raphael.paper.text(), .circle(), etc.
     * @param rEventName -- "click", etc.
     */
    triggerRaphaelEvent: function( rElement, eventName ) {
        "use strict";
        if( rElement && eventName ) {
            for( var i = 0, len = rElement.events.length; i < len; i++ ) {
                if( rElement.events[i].name === eventName ) {
                    rElement.events[i].f.call( rElement );
                }
            }
        }
    },

    /**
     * Add a multiplier to some pixel value to increase screen sizes for touch devices
     * @param scalar
     */
    getTouchAdjustedSize: function( scalar ) {
        const scale = (scalar > 10) ? 1.5 : 2;
        return( Dyn.environment.isTouchDevice() ? (scale * scalar) : scalar );
    },

    /**
     * Change plot colors to match the given color theme.
     * Note:
     *  - these colors are ones that are assigned dynamically.
     *  - in addition many static plot colors are changed via styles, see style.scss and _plotview.scss.
     *  - see Dyn.plotThemeColors for the color constants for each theme.
     * @param theme - theme name/key
     * @param subTheme - optional sub-theme for testing, see Dyn.plotThemeColors.testThemes
     */
    setThemeColors: function( theme, subTheme) {
        theme = getColorContrastsByMode(theme, Dyn.preferences.getMode());
        // iterating over Dyn.plotThemeColors[theme].* to update Dyn.plotUtil.* where key name is the same.
        Object.keys( Dyn.plotThemeColors[theme] ).forEach( key => {
            let oldVal = Dyn.plotUtil[key],
                newVal = Dyn.plotThemeColors[theme][key];
            Dyn.assert( Dyn.plotThemeColors.isValidThemeValue( oldVal ),
                "setThemeColors(): Dyn.plotUtil."+key+" was not initialized properly. type="+typeof(oldVal));
            Dyn.assert( Dyn.plotThemeColors.isValidThemeValue( newVal ),
                "setThemeColors(): Dyn.plotThemeColors."+theme+"."+key+" was not initialized properly. type="+typeof(newVal));
            //console.log( "setThemeColors(): Dyn.plotUtil."+key/*+" from Dyn.plotThemeColors."+theme+"."+key*/, oldVal, newVal );
            Dyn.plotUtil[key] = Dyn.plotThemeColors.getThemeColor( theme, key );
        });

        // recalc background brightness
        Dyn.plotUtil.caseBackgroundBrightness = Dyn.colorUtil.getColorBrightness( Dyn.plotUtil.normalDropColor );

        if( Dyn.debugging && subTheme ) {
            // TEST of colors, by modifying the theme here with selective overrides
            const themeOverRides = Dyn.plotThemeColors.testThemes[subTheme];
            if( themeOverRides ) {
                console.log("setThemeColors() is switching to: "+subTheme );
                Object.keys( themeOverRides ).forEach( key => {
                    Dyn.plotUtil[key] = themeOverRides[key];
                });
            } else {
                 console.warn("setThemeColors() did not find test theme: ", theme, subTheme );
            }
        }
    },

    /**
     * Check if current plot is in Jr mode to control axis label
     * and size of the case and font
     * @returns boolean value
     */
    isTuvaJr: function() {
        return Dyn.preferences.getMode() === 'jr';
    },

    isTuvaJrPlay: function() {
        return Dyn.preferences.getMode() === 'jr' && !Dyn.plotView;
    },

    /**
     * Are we in draw mode? See also isDrawModeAuthoring()
     * Draw mode has an empty dataset and plot, hidden Case Card and Table panels.
     */
    isDrawOnly: function() {
        return Dyn.preferences.getMode() === 'draw'
    },

    /** are we in draw mode (empty dataset and plot) and in the authoring tool? */
    isDrawModeAuthoring() {
        return Dyn.preferences.getMode() === 'draw' && Dyn.plotUtil.isAuthoring();
    },

    /**
     * Are we in the authoring tool?
     */
    isAuthoring() {
        return !!Dyn.isAuthoring;
    },

    /**
     * Allow this element to have the keyboard focus (e.g. tab to select)
     * Typically called once after initializing the element.
     * @param element -- Raphael element
     * @param optionalKeydownHandler
     * @param [optionalAriaLabel]
     */
    setKeyboardFocusable: function( element, optionalKeydownHandler, optionalAriaLabel ) {
        Dyn.assert( element && element.node );
        element.node.setAttribute( "focusable", "true" );
        element.node.setAttribute( "tabindex", "0" );
        if( optionalKeydownHandler ) {
            element.node.onkeydown = optionalKeydownHandler;
        }
        if( optionalAriaLabel ) {
            element.node.setAttribute( "aria-label", optionalAriaLabel );
        }
    },

    /**
     * Cover function to set keyboard focus to this Raphael element.
     * Typically called during a dragEnd() event handler, so that
     * after click/drag the user can use the arrow keys to control further.
     * This is not needed for elements with click handlers,
     * they automatically become the keyboard focus on click.
     * @param element
     */
    setAsKeyboardFocus: function( element, focus=true ) {
        Dyn.assert( element?.node );
        if( focus ) {
            element?.node.focus();
        } else {
            element?.node.blur();
        }
        // NOTE: to debug keyboard focus in Chrome:
        //  In debugger, click Console, click Create Live Expression (eye icon),
        //  type: document.activeElement, click outside the live expression panel to save
        //  https://developers.google.com/web/tools/chrome-devtools/accessibility/focus
        //console.log("focus", element.type );
    },

    /** see setAsKeyboardFocus() */
    isKeyboardFocus( element ) {
        return element?.node === document.activeElement;
    },

    arrowKeyLastPressMS: 0,         // updated by arrowKeyAcceleratedDistance()
    arrowKeyLastAccelerateValue: 1, // updated by arrowKeyAcceleratedDistance()
    arrowKeyMaxAccelerateValue: 5,  // constant

    /**
     * Get the distance the arrow key should travel, with keyboard acceleration.
     * E.g. to move an annotation with the up arrow, press once to move 1 pixel,
     * and press again to double movement distance, up to 10x.
     * @returns {number} -- [1-10]
     */
    arrowKeyAcceleratedDistance: function( keyDownCode ) {
        let dist = { dx:0, dy:0 },
            currentPressMS = Date.now(), // time in milliseconds
            deltaPressMS = currentPressMS - this.arrowKeyLastPressMS;

        // update arrowKeyLastAccelerateValue, arrowKeyLastPressMS
        if( deltaPressMS > 500 ) {
            // >0.5 seconds between arrow key presses, reset to 1
            this.arrowKeyLastAccelerateValue = 1;
        } else {
            // else accellerate distance by one, up to max
            this.arrowKeyLastAccelerateValue = Math.min( this.arrowKeyMaxAccelerateValue, this.arrowKeyLastAccelerateValue + 1);
        }
        this.arrowKeyLastPressMS = currentPressMS;
        //console.log("arrowKeyAcceleratedDistance", this.arrowKeyLastAccelerateValue, "deltaPressMS", deltaPressMS );

        // convert keycode+value to a dx, dy distance
        let value = this.arrowKeyLastAccelerateValue;
            dist = {
                dx: (keyDownCode==="ArrowLeft")? -value : ((keyDownCode==="ArrowRight")? value: 0 ),
                dy: (keyDownCode==="ArrowUp")  ? -value : ((keyDownCode==="ArrowDown") ? value: 0 )
            };
        return dist;
    },

    /**
     * from https://stackoverflow.com/questions/54961620/test-if-svg-path-d-property-string-is-valid
     * false means it is definitely invalid
     * true *doesn't* mean it's definitely valid
     * @param pathString
     * @returns {boolean}
     */
    isValidPathStringForSVG: function( pathString ) {
        const reEverythingAllowed = /[MmZzLlHhVvCcSsQqTtAa0-9-,.\s]/g;
        const bContainsIllegalCharacter = !! pathString.replace(reEverythingAllowed,'').length;
        const bContainsAdjacentLetters = /[a-zA-Z][a-zA-Z]/.test(pathString);
        const bInvalidStart = /^[0-9-,.]/.test(pathString);
        const bInvalidEnd = /.*[-,.]$/.test(pathString.trim());
        let isNonEmptyString = (pathString && typeof pathString === "string");

        return isNonEmptyString && !(bContainsIllegalCharacter || bContainsAdjacentLetters || bInvalidStart || bInvalidEnd);
    },

    /**
     * destroy and remove the SVG layer and all paper elements from the window.
     * Caller should set all references to the paper and elements to null to complete
     * the removal.
     */
    destroyPaperAndSVGObjects( paper ) {
        try{
            paper.clear();
            paper.remove();
        }
        catch (error) {
            // this catches the error and allows you to proceed along nicely
        }
    },

    unitTest() {
        let unitTester = new Dyn.UnitTester("Dyn.plotUtil.unitTest()");

        Dyn.plotUtil.unitTest_validateSVG_PathString( unitTester );

        Dyn.plotThemeColors.unitTest( unitTester );

        // test areaOfTriangle()
        [   [ 2, { x:0, y:0 }, { x:2, y:2 }, { x:2, y:0 } ],
            [ 2, { x:10, y:0 }, { x:12, y:2 }, { x:12, y:0 } ],
            [ 2, { x:10, y:100 }, { x:12, y:102 }, { x:12, y:100 } ]]
            .forEach( (aot) => {
                aot.push( this.areaOfTriangle( aot[1], aot[2], aot[3]))
                unitTester.test( aot[0] === aot[4], "area of triangle error, got:"+aot[4]+', not:'+aot[0] );
            });

        unitTester.report();
        return true;
    },

    unitTest_validateSVG_PathString: function( unitTester ) {
        const sValid = `
  M 213.1,6.7
  c -32.4-14.4-73.7,0-88.1,30.6
  C 110.6,4.9,67.5-9.5,36.9,6.7
  C 2.8,22.9-13.4,62.4,13.5,110.9
  C 33.3,145.1,67.5,170.3,125,217
  c 59.3-46.7,93.5-71.9,111.5-106.1
  C 263.4,64.2,247.2,22.9,213.1,6.7
  z
`;
        const sOtherValid = 'M213.1,6.7c-32.4-14.4-73.7,0-88.1,30.6C110.6,4.9,67.5-9.5,36.9,6.7C2.8,22.9-13.4,62.4,13.5,110.9';
        function test( t ) {
            unitTester.test( t, "! isValidPathStringForSVG");
        }

        test( this.isValidPathStringForSVG(sValid));
        test( this.isValidPathStringForSVG(sOtherValid));
        // these are invalid paths for SVG:
        test( false===this.isValidPathStringForSVG('bro'));
        test( false===this.isValidPathStringForSVG('M213.1,6.7c-32.4-14.4-73.7,0-88.1,30.6C110.6,4.9,67.5-9.5,36.9,6.7C2.8,22.9-13.4,62.4,13.5,110.'));
        test( false===this.isValidPathStringForSVG('213.1,6.7c-32.4-14.4-73.7,0-88.1,30.6C110.6,4.9,67.5-9.5,36.9,6.7C2.8,22.9-13.4,62.4,13.5,110.9'));
        test( false===this.isValidPathStringForSVG('MM213.1,6.7c-32.4-14.4-73.7,0-88.1,30.6C110.6,4.9,67.5-9.5,36.9,6.7C2.8,22.9-13.4,62.4,13.5,110.9'));
        test( false===this.isValidPathStringForSVG('K213.1,6.7c-32.4-14.4-73.7,0-88'));
    },
}; // end Dyn.plotUtil

Dyn.debegPlotUtil_UnitTestHasRun = ( Dyn.debugging ? Dyn.plotUtil.unitTest() : false );

    class PlotScrollbar {
        constructor( paper, isHorizontal, updateCallBackFunction ) {
            this.windowSize = 0;    // logical, scrollable plot area size, in pixels along scroll axis
            this.offset = 0;        // offset of window in view, in pixels (0 = top of scrollbar)
            this.bounds = null;
            this.showBar = false;
            this.isHorizontal = Boolean( isHorizontal );

            this.paper = paper;
            this.bar = null;    // the visible rectangle of the scrollbar, where the thumb moves
            this.thumb = null;  // the draggable "thumb" round rect of the scrollbar
            this.updateFunction = updateCallBackFunction; // optional callback function when scrollbar moves
            Dyn.assert( (! this.updateFunction) || typeof this.updateFunction === "function", "function expected");
            this.dragThumbTimeout = null;

            this.initView( paper );
        }

        static #kBarWidth = 14;
        static #kThumbWidth = 8;
        static #kThumbRound = 4;
        static #kBarOutlineColor = "#ddd";
        static #kBarFillColor = "#fff";
        static #kThumbColor = "#949494";
        static #kThumbSelectedColor = "#999";
        static #stdAnimationMS = 250; // 0.25 seconds
        static #quickAnimationMS = 50;

        setViewRect( left, top, right, bottom ) {
            // show view rectangle for debugging
            //if( this.debugParentRect ) this.debugParentRect.remove();
            //this.debugParentRect = this.paper.
            //    rect( left, top, Math.max(0, right-left), Math.max(0, bottom-top), 0 ).
            //    attr( { fill: "none", stroke: "red" });

            if( this.isHorizontal ) {
                top = Math.max( top, bottom-PlotScrollbar.#kBarWidth );
            } else {
                left = Math.max( left, right-PlotScrollbar.#kBarWidth );
            }
            this.bounds = new Dyn.mathUtil.Rect( left, top, right-left, bottom-top );
            return this; // allow chaining
        }

        setWindowSize( size, bottomMargin ) {
            this.windowSize = Math.max( 0, size ) + Math.max( 0, bottomMargin );
            this.setOffset( this.offset ); // if window has shrunk, offset should shrink
            return this; // allow chaining
        }

        setOffset( offset ) {
            var viewSize = ( this.isHorizontal ? this.bounds.width : this.bounds.height ),
                minScrollSize = 0,
                maxScrollSize = Math.max(0, this.windowSize - viewSize );
            this.offset = Dyn.mathUtil.clipToRange( offset, minScrollSize, maxScrollSize );
        }

        hide() {
            this.windowSize = this.offset = 0;
            this.showBar = false;
            if( this.bar ) {
                this.bar.hide();
                this.thumb.hide();
            }
            return this; // allow chaining
        }

        getBarThickness() {
            // get the thickness of the bar; return zero if bar is hidden
            return (this.showBar ? (this.isHorizontal ? this.bounds.height : this.bounds.width ): 0 );
        }

        getScrollOffset() {
            // offset of scrollbar in pixels; range is [0 - this.windowSize];
            return this.offset;
        }

        /**
         * Layer the visual elements from back to front (z-axis)
         */
        toFront() {
            this.bar.toFront();
            this.thumb.toFront();
        }

        initView( paper ) {
            var thisScrollbar = this;

            function thumbHoverIn( event ) {
                event.currentTarget.style.cursor = Dyn.plotUtil.cursorPointer;
                thisScrollbar.thumb.animate( { fill: PlotScrollbar.#kThumbSelectedColor }, PlotScrollbar.#stdAnimationMS );
            }
            function thumbHoverOut( event ) {
                event.currentTarget.style.cursor = Dyn.plotUtil.cursorDefault;
                thisScrollbar.thumb.animate( { fill: PlotScrollbar.#kThumbColor }, PlotScrollbar.#stdAnimationMS );
            }

            this.bounds = new Dyn.mathUtil.Rect();
            this.bar = paper.rect( this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height, 0 )
                .attr( { fill: PlotScrollbar.#kBarFillColor, stroke: PlotScrollbar.#kBarOutlineColor })
                .click( ( event ) => { this._clickOnBar( event ); } )
                .hide();
            this.thumb = paper.rect( this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height, PlotScrollbar.#kThumbRound )
                .attr( { fill: PlotScrollbar.#kThumbColor , stroke: "none" })
                .drag( ( dx, dy, x, y, event ) => this._dragMoveThumb( dx, dy, x, y, event ),
                    ( x, y, event ) => this._dragStartThumb( x, y, event ),
                    ( event ) => this._dragEndThumb( event ))
                .hover( thumbHoverIn, thumbHoverOut )
                .hide();
            return this; // allow chaining
        }

        updateView() {
            let viewSize = this._getViewSize(); // view size in scrolling dimension
            if( this.windowSize > viewSize ) {  // if amount to show is larger than view, in scrolling dimension

                this.showBar = true;

                // show and update scrollbar
                this.bar.attr( {
                    x: this.bounds.x,
                    y: this.bounds.y,
                    height: this.bounds.height,
                    width: this.bounds.width
                } ).show();
                this._updateThumb( viewSize, PlotScrollbar.#stdAnimationMS );
            } else {
                // hide scrollbar
                this.hide();
            }
            return this; // allow chaining
        }

        _getViewSize() {
            return( this.isHorizontal ? this.bounds.width : this.bounds.height ); // view size in scrolling dimension
        }

        _updateThumb( viewSize, animationTimeMs ) {
            if( this.showBar ) {
                // position thumb (scale from window size to current view size)
                // include blank space around thumb on all 4 sides
                let thumbSpacer = (PlotScrollbar.#kBarWidth - PlotScrollbar.#kThumbWidth) / 2, // perpendicular to scrolling axis
                    viewProportion = (viewSize / this.windowSize), // window to view scaling
                    thumbViewLength = Math.max( thumbSpacer, (viewProportion * viewSize) - (2 * thumbSpacer) ),
                    thumbViewOffset = thumbSpacer + (viewProportion * this.offset);
                this.thumb.animate( {
                    x: this.bounds.x + (this.isHorizontal ? thumbViewOffset : thumbSpacer),
                    y: this.bounds.y + (this.isHorizontal ? thumbSpacer : thumbViewOffset),
                    width: (this.isHorizontal ? thumbViewLength : PlotScrollbar.#kThumbWidth ),
                    height: (this.isHorizontal ? PlotScrollbar.#kThumbWidth : thumbViewLength)
                }, animationTimeMs ).show();
            }
        }

        _clickOnBar( event ) {
            // move content up or down to see the next section of content
            const fractionToMove = 0.8; // overlap by 1/5 of view size
            var mouseLoc = Dyn.plotUtil.getClickEventPaperXY( event, this.bar )[this.isHorizontal ? 'x' : 'y'],
                thumbLoc = this.thumb.attr( this.isHorizontal ? 'x' : 'y' ),
                isClickBelowThumb = mouseLoc <= thumbLoc,
                viewSize = ( this.isHorizontal ? this.bounds.width : this.bounds.height ),
                delta = fractionToMove * viewSize * ( isClickBelowThumb ? -1 : 1 );
            // move scrolling offset
            this.setOffset( this.offset + delta );
            if( this.updateFunction ) {
                this.updateFunction();
            } else {
                this.updateView();
            }
            Dyn.plotUtil.safeStopPropogation( event );
        }

        _dragMoveThumb( dx, dy, x, y, event ) {
            var viewSize = ( this.isHorizontal ? this.bounds.width : this.bounds.height ), // view size in scrolling dimension
                viewToWindowScale = ( this.windowSize / viewSize ),
                viewDelta = ( this.isHorizontal ? dx : dy ),
                windowDelta = viewDelta * viewToWindowScale,
                newOffset = this.thumb.data("offsetStart") + windowDelta;

            // for quick feedback, update the thumb only
            this.setOffset( newOffset ); // change the scrollbar offset
            this._updateThumb( this._getViewSize(), PlotScrollbar.#quickAnimationMS );

            // on a delay, update the rest of the view, so that multiple updates are consolidated
            if( this.dragThumbTimeout ) {
                clearTimeout( this.dragThumbTimeout );
            }
            this.dragThumbTimeout = setTimeout(() => {
                //console.log( "_dragMoveThumb updateFunction()" );
                if ( this.updateFunction ) {
                    this.updateFunction();
                } else {
                    this.updateView();
                }
                this.dragThumbTimeout = null;
            }, 250);
            Dyn.plotUtil.safeStopPropogation( event );
        }

        _dragStartThumb( x, y, event ) {
            this.thumb.data("offsetStart", this.offset );
        }

        _dragEndThumb( event ) {
        }
    } // class PlotScrollbar
    Dyn.PlotScrollbar = PlotScrollbar;


// class PlotLabelsUtil MOVED to plotLabels.js
// Dyn.PlotLabelsUtil = PlotLabelsUtil;


/**
 * Helper object that can register Dyn.PlotElement constructors,
 * and restore those objects on request.
 * @type {{registerType: registerType, restore: restore}}
 */
Dyn.PlotElemHelper = {

    constructorFunctions: {},
    oldTypeConversionFunctions: {},

	/** statically register the association of the control string with the constructor */
	registerType : function( controlString, constructorFunc  ) {
        Dyn.assert( this.isGoodType( controlString ));
		Dyn.assert( this.isGoodConstructor( constructorFunc ));
        Dyn.assert( ! this.constructorFunctions[ controlString ], "registerType() error: controlString: "+controlString+" exists in constructorFunctions");
        Dyn.assert( ! this.oldTypeConversionFunctions[ controlString ], "registerType() error: controlString: "+controlString+" exists in oldTypeConversionFunctions");
        this.constructorFunctions[ controlString ] = constructorFunc;
	},

    /**
     * statically register the association of the control string with a conversion function.
     * e.g. registerOldType( 'controlsBarChart', (savedData, partialPlotState) => {
     *          // return either a Bar Chart of Values constructor or Bar Chart of Frequencies constructor.
     *          return ( savedData.isStacked) ? Dyn.ValueBarElement : Dyn.FreqBarElement });
     */
    registerOldType : function( controlString, conversionFunction  ) {
        Dyn.assert( this.isGoodType( controlString ));
        Dyn.assert( this.isGoodConstructor( conversionFunction ));
        Dyn.assert( ! this.constructorFunctions[ controlString ], "registerType() error: controlString: "+controlString+" exists in constructorFunctions");
        Dyn.assert( ! this.oldTypeConversionFunctions[ controlString ], "registerType() error: controlString: "+controlString+" exists in oldTypeConversionFunctions");
        this.oldTypeConversionFunctions[ controlString ] = conversionFunction;
     },

    /**
     *  Restore the Dyn.PlotElement subclass using its saved data and primary type.
     *
     *  Note: savedData.primaryType may be Dyn.EPlotControl.kControlsOldBestFit or another obsolete value,
     *  in which case plotElement.primaryType !== savedData.primaryType.
     *  The override of plotElement.restore() can check for this, so it knows that it is converting
     *  an old plot type into a newer one, and can act appropriately.
     */
	restore : function( savedData, partialPlotState ) {
		var plotElement = null;

		if( savedData.primaryType ) {
			let constructorFunc = this.constructorFunctions[ savedData.primaryType ],
                converterFunc = this.oldTypeConversionFunctions[ savedData.primaryType ];
			if( converterFunc ) {
			    constructorFunc = converterFunc( savedData, partialPlotState ); // dynamically get the constructor if registerOldType() was used.
            }
			if( this.isGoodConstructor( constructorFunc )) {
				plotElement = new constructorFunc( Dyn );
				plotElement.restore( savedData );
			} else {
                Dyn.assert( this.isGoodConstructor( constructorFunc ), "ERROR: unknown/unhandled Dyn.PlotElement.primaryType=='"+savedData.primaryType+"'" );
				console.warn("ERROR Dyn.PlotElemHelper.restore can't restore Dyn.PlotElement.primaryType='"+savedData.primaryType+"', ignoring this plot element." );
			}
		}
		return plotElement; // object of class Dyn.PlotElement or null (if caller should discard this data)
	},

    /** Restore a plot element on the X or Y axis to the other axis, as indicated by newControlType. */
    restoreSwapped : function( oldControlType, newControlType, savedData, partialPlotState=null ) {
        Dyn.assert( oldControlType === savedData.primaryType );
        Dyn.assert( this.isGoodType( newControlType) ); // may or may not be the same as oldControlType
        let plotElement = null,
            constructorFunc = this.constructorFunctions[ newControlType ];
        if( this.isGoodConstructor( constructorFunc )) {
            plotElement = new constructorFunc( Dyn );
            plotElement.restore( savedData );
        } else {
            console.warn("ERROR Dyn.PlotElemHelper.restoreSwapped can't restore Dyn.PlotElement.primaryType='"+savedData.primaryType+"', ignoring this plot element." );
        }
        return plotElement;
    },

    /**
     * Create the registered plot element with default values
     * NOTE: in the future we can extend this to allow construction parameters
     * @param controlString
     */
    create : function( controlString, optionalParam ) {
        var plotElement = null;

	    if( this.isGoodType( controlString )) {
            let constructorFunc = this.constructorFunctions[ controlString ];
            if( this.isGoodConstructor( constructorFunc )) {
                plotElement = new constructorFunc( Dyn, optionalParam );
            }
        }
	    return plotElement;
    },

    isGoodType : function( controlString ) {
        return typeof controlString === "string" && /controls*/.test( controlString ) && Dyn.EPlotControl.isControlType( controlString );
    },

    isGoodConstructor : function( constructorFunc ) {
        return constructorFunc && (typeof constructorFunc === "function");
    },

    isGoodConverterFunction : function( conversionFunction ) {
        return conversionFunction && (typeof conversionFunction === "function");
    },

    unitTest() {
        let unitTester = new Dyn.UnitTester("Dyn.PlotElemHelper.unitTest()");
        // for each registered type
        for( let controlString in this.constructorFunctions ) {
            unitTester.test( this.isGoodType(controlString), "bad constructorFunctions control string:"+controlString );
            // create the type and then test save and restore
            let plotElement = this.create( controlString, null ),
                savedData = plotElement.save();
            plotElement.restore(savedData);
            unitTester.test( plotElement.primaryType === controlString, "bad .save() with constructorFunctions: "+controlString+" makes type "+plotElement.primaryType );
            //console.log("PlotElemHelper.unitTest constructorFunctions", controlString, savedData );
        }
        for( let controlString in this.oldTypeConversionFunctions ) {
            unitTester.test( this.isGoodType(controlString), "bad oldTypeConversionFunctions control string:"+controlString );
            let constructorFunc = this.constructorFunctions[ controlString ],
                converterFunc = this.oldTypeConversionFunctions[ controlString ];
            unitTester.test( this.isGoodConverterFunction(converterFunc), "bad oldTypeConversionFunctions converter function for:"+controlString );
            if( converterFunc ) {
                let partialPlotState = { plotElements:[] },
                constructorFunc = converterFunc( { primaryType:controlString }, partialPlotState ); // dynamically get the constructor if registerOldType() was used.
                unitTester.test( this.isGoodConstructor(constructorFunc), "bad oldTypeConversionFunctions constructor function for:"+controlString );
                let plotElement = new constructorFunc( Dyn, null ),
                    savedData = plotElement.save();
                plotElement.restore(savedData);
                unitTester.test( plotElement.primaryType !== controlString, "bad .save() with oldTypeConversionFunctions: "+controlString+" makes type "+plotElement.primaryType );
                //console.log("PlotElemHelper.unitTest oldTypeConversionFunctions", controlString, savedData );
            }
        }
        unitTester.report();
        return true;
    }
};

// Run Dyn.PlotElemHelper.unitTest(), with delay the test until all plot elements have been registered with registerType() or registerOldType()
setTimeout( () => {
    Dyn.debugPlotElemHelper_UnitTestHasRun = ( Dyn.debugging ? Dyn.PlotElemHelper.unitTest() : false );
}, 100 );

} // wrapDynplotUtil
